export const define_hi = {
  //landing page casestudies component

  landing_caseStudies1:
    "सिवी ने ग्लेंडेल, ला में एक सड़क सौंदर्यीकरण कार्यक्रम का बीटा-परीक्षण किया। शहर के बारे में प्राप्त टिप्पणियों के आधार पर, यह पुष्टि की गई थी कि परियोजना शुरू होने और दिखाई देने तक निवासियों ने परियोजना के बारे में पूरी तरह से परामर्श नहीं किया है। सिवी का लक्ष्य सभी मौजूदा और आगामी परियोजनाओं से इस परिदृश्य को खत्म करना है।",

  landing_caseStudies2:
    "एक बड़ी सरकारी अवसंरचना एजेंसी सिवि का उपयोग करने की योजना बना रही है ताकि वे अपने अगले बाहरी आउटरीच कार्यक्रम का संचालन कर सकें। एजेंसी उन निवासियों से पूछेंगी जो वे सेवा करते हैं, नई परियोजनाओं के बारे में प्रश्न जो वे प्रस्तावित कर रहे हैं। साथ ही, वे Civy का उपयोग ऐसे व्यक्तियों के संपर्क में रहने के लिए भी करेंगे जो सभी मौजूदा बुनियादी ढाँचे वाली परियोजनाओं के लिए मुद्दों की रिपोर्ट कर रहे हैं। उन्होंने महसूस किया कि एक स्वतंत्र मोबाइल-सक्षम प्लेटफ़ॉर्म सगाई और इस तथ्य को बेहतर करेगा कि सिवी सरलता से काम करता है, जिसमें विभिन्न भाषा विकल्प अधिकांश लोगों से संबंधित हैं।",

  landing_caseStudies3:
    "आपको बेहतर परिप्रेक्ष्य प्रदान करने के लिए एक हालिया परिदृश्य, कल्पना कीजिए कि आप शहर के अधिकारी या सरकारी एजेंसी या इच्छुक निवासी हैं। आप लॉस एंजिल्स में स्थित हैं। आप अपने शहर का नाम सिवी के डैशबोर्ड या दुनिया भर के किसी भी अन्य शहर में रख सकते हैं (जैसा कि सिडनी, ऑस्ट्रेलिया कहते हैं)। आप देख सकते हैं कि सिडनी क्या कर रहा है, आप प्रोजेक्ट श्रेणी के अनुसार फ़िल्टर लागू कर सकते हैं। यह वैश्विक शिक्षा और शिक्षाओं को बढ़ावा देगा।",

  landing_caseStudies4:
    "कैलिफोर्निया के न्यूपोर्ट बीच के निवासी के रूप में, मैंने आउटडोर फिटनेस स्टेशनों की कमी पर ध्यान दिया। ये कई अन्य देशों में बहुत आम हैं जहां सूरज, महासागर और हरियाली बहुतायत में हैं। अपने स्मार्टफोन का उपयोग करते हुए, मैंने सिवी में एक नया प्रोजेक्ट बनाया (जिसका नाम है आउटडोर फिटनेस स्टेशन), स्थान को चिह्नित किया, कुछ उदाहरण चित्र जोड़े, परियोजना के मामले का एक संक्षिप्त विवरण जोड़ा, और इसे अपने स्थानीय शहर विभाग और सिवी नेटवर्क के साथ साझा किया। इसका उद्देश्य निवासियों को विचार का समर्थन करना है या टिप्पणी या अन्य सुझाव प्रदान करना है; और इस बीच, शहर विभाग इस निवासी की प्रतिक्रिया प्राप्त कर रहा है। इससे उन्हें अभिनय करने और अपने अगले समुदाय के लोगों के साथ जुड़ने, लोगों का समर्थन पाने और उसे बनाने की प्रेरणा मिलती है।",

  landing_caseStudies_content:
    "सिवि आपके दिन के औसत दिन में कैसे फायदेमंद हो सकता है, इसके कुछ व्यावहारिक उदाहरण हैं।",

  landing_caseStudies_title: "मामले का अध्ययन",

  //landing page statistics component

  landing_statistics_title: "सांख्यिकीय",

  landing_statistics_content:
    "सतत विकास को पूरी तरह से लाने के लिए हमें प्रगति को समान और व्यापक आधार बनाना चाहिए और लोगों को उस प्रक्रिया में सक्रिय भागीदार बनने में सक्षम बनाना चाहिए।",

  landing_statistics48:
    "वयस्कों के सीधे एक नागरिक समूह या गतिविधि में भाग लेते हैं",

  landing_statistics68:
    "18 से 34 साल के निवासियों ने बताया कि उन्हें सरकार से छूट मिली हुई है।",

  //landing page testimonial component

  landing_testimonial_title: "प्रशंसापत्र",

  landing_testimonial_content: "हमारे नवीनतम ग्राहकों के प्रशंसापत्र पढ़ें।",

  landing_testimonial1:
    "काश, मेरे पास यह होता जब हम उन परियोजनाओं पर काम करते, जिनके लिए राज्य-व्यापी और स्थानीय हितधारकों की जरूरत होती। इसने कुछ तनाव को दूर किया और हमें प्रभावी रूप से समुदायों तक पहुंचने में मदद की।",

  landing_testimonial1_author: "अलना",

  landing_testimonial1_postname:
    "- पूर्व आउटरीच और संचार निदेशक, राज्य उपयोगिता प्राधिकरण",

  landing_testimonial2:
    "सिवी एक बार में सगाई की प्रक्रिया में तीन भूमिकाएं निभा सकता है - अपने काम को स्ट्रीम करना।",

  landing_testimonial2_author: "एरिक",

  landing_testimonial2_postname:
    "- फ्रीहोल्डर टाउनशिप, न्यू जर्सी में विधायी सहयोगी",

  landing_testimonial3:
    "सरकारी सॉफ्टवेयर के लिए लंबे समय में सिवी पहला रोमांचक घटनाक्रम है और कैसे नगरपालिका जनता के साथ बातचीत करती है। फ्रीहोल्डर एक प्रमुख नगर पालिका है",

  landing_testimonial3_author: "स्कॉट",

  landing_testimonial3_postname: "- चीफ ऑफ स्टाफ, स्टेट असेंबलीमैन",

  landing_testimonial4:
    "Civy का ऑनलाइन एंगेजमेंट प्लेटफॉर्म शहरों, सरकारों और निवासियों को ध्यान में रखते हुए उपयोग में आसान और डिज़ाइन किया गया है। यह शहरों और निर्वाचित-अधिकारियों के रूप में हमारे द्वारा अनुभव किए जाने वाले प्रमुख दर्द-बिंदुओं को संबोधित कर रहा है, और हमारे निवासियों को हमारे साथ सुरक्षित और सुरक्षित वातावरण में संलग्न करना आसान बनाता है। मंच हमारी मौजूदा आउटरीच रणनीतियों का अनुपालन करता है और बढ़ाता है, और पार्टिसिपेशन दरों और इक्विटी को बढ़ाने के लिए डिज़ाइन किया गया है।",

  landing_testimonial4_author: "थेरेसा ब्रनेला",

  landing_testimonial4_postname: "-मायोर, ब्रुकलोन, न्यू जर्सी",

  //landing page services component

  landing_servicesA_header: "व्यापक सार्वजनिक परियोजनाओं के लिए आउटरीच।",

  landing_servicesA_content:
    "एक एकल मंच जो नागरिक परियोजनाओं के लिए व्यापक पहुंच, कई भाषाओं और जनसांख्यिकीय गहराई प्रदान करता है।",

  landing_servicesB_header: "गोपनीयता और डेटा सुरक्षा।",

  landing_servicesB_content:
    "हमारे प्लेटफॉर्म में निवासी प्रतिक्रियाओं की रक्षा के लिए अतिरिक्त गोपनीयता उपाय शामिल हैं, जो केवल शहर और सरकारी अधिकारियों को दिखाई देते हैं।",

  landing_servicesC_header: "कुशल और सुविधाजनक।",

  landing_servicesC_content:
    "एक परियोजना के लिए सिवी पर प्रतिक्रिया एक पाठ संदेश भेजने के रूप में आसान है।",

  landing_servicesD_header: "व्यापक विश्लेषण।",

  landing_servicesD_content:
    "विभिन्न जनसांख्यिकी में निवासी प्रतिक्रिया का विश्लेषण करें और तेजी से निर्णय लेने, अनुमोदन और भविष्य की योजना बनाने के लिए विश्लेषिकी लागू करें।",

  landing_service_title: "सेवा",

  landing_service_content:
    "सिवी शहरों और सरकारों को नागरिक जुड़ाव में सुधार करने में मदद करता है।",

  landing_ServiceSection_maincontent:
    "सिवी राज्य, शहर, ज़िप कोड द्वारा सूचीबद्ध सरकारों और शहरों द्वारा परियोजनाओं को प्रदर्शित करता है; और ऐसे प्रश्न पूछें, जिनका उत्तर निवासी दे सकते हैं। ",

  //landing page project component

  landing_project_title: "परियोजनाओं",

  landing_project_content:
    "विभिन्न शहरों में हमारी वर्तमान परियोजनाओं की सूची।",

  landing_project_short_description: "प्रोजेक्ट लघु विवरण",

  landing_project_description_link: "और देखो",

  landing_project_startdate: "आरंभ करने की तिथि",

  landing_project_enddate: "अंतिम तिथि",

  //landing page benefit component

  landing_benefit1_title: "मोबाइल प्लेटफॉर्म",

  landing_benefit1_content:
    "Civy एक सुविधाजनक मोबाइल प्लेटफ़ॉर्म है जो आसानी से कहीं से भी आसानी से उपलब्ध है।",

  landing_benefit2_title: "निवासियों के लिए नि: शुल्क",

  landing_benefit2_content:
    "Civy निवासियों को पंजीकरण, सवालों और सर्वेक्षणों का जवाब देने और शहरों और सरकारों को अपनी परियोजना योजना और वितरण में सुधार करने में मदद करने के लिए स्वतंत्र है।",

  landing_benefit3_title: "सोशल मीडिया लिंकेज",

  landing_benefit3_content:
    "भागीदारी दर और जनसांख्यिकीय गहराई बढ़ाने के लिए सोशल मीडिया प्लेटफार्मों के साथ सिवी लिंक।",

  landing_benefit4_title: "सकुशल सुरक्षित",

  landing_benefit4_content:
    "निवासी प्रतिक्रियाएं गोपनीय हैं और सिवी 3 जी पार्टियों के साथ निवासी डेटा साझा नहीं करता है।",

  landing_benefit_title: "लाभ",

  landing_benefit_content:
    "सिवी व्यापक सार्वजनिक जुड़ाव और भागीदारी का लाभ उठाने के लिए कई सुविधाएँ प्रदान करता है जो बेहतर प्रशासन और विकास परिणामों में योगदान करते हैं।",

  //landing page about component

  landing_about_title: "CIVY के बारे में",

  landing_about_content:
    "हम शहरों और सरकारों को नागरिक परियोजनाओं में हितधारक सगाई और सार्वजनिक आउटरीच में सुधार करने में मदद करते हैं।",

  landing_about_maincontent:
    "शहरों और सरकारों द्वारा वर्तमान और आगामी सार्वजनिक परियोजनाओं पर प्रतिक्रिया में भाग लेने और साझा करने के लिए सिवी निवासियों के लिए एक आसान और सुरक्षित तरीका है। एक समर्पित ऑनलाइन प्लेटफ़ॉर्म जो व्यापक दर्शकों तक पहुंचता है। सभी जनसांख्यिकी के हितधारक अपने शहरों और सरकारी एजेंसियों को सुविधा और दक्षता के साथ प्रतिक्रिया देते हैं। ",

  landing_readmore: "अधिक पढ़ें",

  //landing page contact us component

  landing_contactus_address_title: "पता",

  landing_contactus_address: "सिवी इंक।",

  landing_contactus_address_post:
    "160 एस साइप्रस सेंट, ऑरेंज, सीए, 92866 यूएसए",

  contactus_address_street: "160 एस साइप्रस सेंट,",

  contactus_address_code: "ऑरेंज, सीए, 92866",

  contactus_address_use: "अमेरीका",

  landing_contactus_address_tel: "दूरभाष:",

  landing_contactus_usertype1: "निवासी",

  landing_contactus_usertype2: "शहर",

  landing_contactus_usertype3: "सरकारी विभाग",

  landing_contactus_usertype4: "विश्वविद्यालय",

  landing_contactus_usertype5: "अन्य",

  landing_contactus_title: "संपर्क में रहो",

  landing_contactus_name: "नाम*",

  landing_contactus_email: "ईमेल*",

  landing_contactus_select: "क्या आप*",

  landing_contactus_feedback: "प्रतिक्रिया का प्रकार*",

  landing_contactus_feedback_good: "अच्छा",

  landing_contactus_feedback_bad: "खराब",

  landing_contactus_feedback_other: "अन्य",

  landing_contactus_feedback_message: "आपका सन्देश*",

  landing_contactus_send_button: "मेसेज भेजें",

  landing_contactus_name_error: "*नाम आवश्यक है",

  landing_contactus_email_error: "*ईमेल जरुरी है",

  landing_contactus_email_error2: "*कृपया मान्य ईमेल पता दर्ज करें",

  landing_contactus_select_error: "*कृपया एक विकल्प चुनें",

  landing_contactus_message_error: "* संदेश आवश्यक है",

  landing_contactus_capcha_error:
    "* कृपया कैप्चा चेकबॉक्स को मान्य करें मैं रोबोट नहीं हूं",

  select_survey_visibility: "सर्वेक्षण दृश्यता का चयन करें",

  select_survey_visibility_private: "निजी",

  select_survey_visibility_public: "सह लोक",

  // services page

  services_casestudy1_title: "शहरों और सरकार",

  services_casestudy1_content:
    "निवासियों को संलग्न करने और नागरिक परियोजनाओं के लिए बेहतर विकास में तेजी लाने के लिए सुरक्षित मंच का उपयोग करना आसान है।",

  services_casestudy2_title: "निवासी",

  services_casestudy2_content:
    "नागरिक परियोजनाओं के डिजाइन और विकास का मार्गदर्शन करने के लिए अपने शहरों के साथ सूचनाएं प्राप्त करने और प्रतिक्रिया साझा करने के लिए एक मोबाइल प्लेटफ़ॉर्म।",

  services_casestudy_title: "मामले का अध्ययन",

  services_casestudy_content:
    "शहर और सरकार सिवि के माध्यम से रेसिडेंशियल से कैसे जुड़ते हैं",

  services_integratedservices_title: "एकीकृत सेवाएं:",

  services_introservice1_title: "सिविल डिफेंस क्या है",

  services_introservice1_point1:
    "शहरों और सरकारों को अपना डेटा बनाने, डेटा एकत्र करने और अपने स्वयं के कथन को नियंत्रित करने में सक्षम बनाता है।",

  services_introservice1_point2:
    "फेसबुक, ट्विटर और लिंक्डइन जैसे अन्य सोशल मीडिया चैनलों के साथ जुड़कर सार्वजनिक आउटरीच को बढ़ाएं और सुधारें।",

  services_introservice1_point3:
    "निवासी प्रतिक्रियाओं की पूरी गोपनीयता, जो केवल शहर या सरकारों को दिखाई दे रही हैं जो CIvy की सदस्यता ले रही हैं। डेटा शहरों या सरकारों के स्वामित्व में है और सिवी तीसरे पक्ष की बिक्री में संलग्न नहीं है।",

  services_introservice1_point4:
    "अपने स्वयं के सर्वर पर प्रोजेक्ट डेटा डाउनलोड और स्टोर करें। गोपनीयता विनियमन का पालन करने के लिए, सिवी ग्राहकों द्वारा परियोजना के पूरा होने के 3 महीने बाद डेटा निकालता है।",

  services_introservice1_point5:
    "अपने अद्वितीय ब्रांडिंग के साथ अपने स्वयं के मंच के रूप में व्हाइट-लेबल सिवी का विकल्प।",

  services_introservice1_point6:
    "सिवी 3 डी होलोग्राफिक और जीआईएस मैपिंग जैसी अतिरिक्त सेवाओं की योजना, डिजाइनिंग, और मार्केटिंग प्रोजेक्ट और शहर के विकास में अनुप्रयोगों की पेशकश करता है।",

  services_introservice2_title:
    "शहरों और सरकारों के लिए उत्पाद की कार्यक्षमता।",

  services_introservice2_point1:
    "शहर और सरकारें सिवी प्लेटफॉर्म पर एक खाता बनाती हैं और अपने स्वयं के सोशल मीडिया चैनलों को लिंक करती हैं।",

  services_introservice2_point2:
    "लोक निर्माण निदेशक जैसे परिभाषित उपयोगकर्ता भूमिकाओं वाले खाते में कई उपयोगकर्ता जोड़ें।",

  services_introservice2_point3:
    "प्रोजेक्ट बनाएं, प्रोजेक्ट के विज़न से संबंधित विवरण, और चित्र अपलोड करें।",

  services_introservice2_point4:
    "विभिन्न चैनलों पर साझा करें और निवासियों से जवाब देने के लिए सवाल पूछें।",

  services_introservice2_point5:
    "प्रतिक्रियाओं को इकट्ठा करें और विश्लेषण करें, हमारी कई भाषा क्षमताओं द्वारा समर्थित समुदाय में अधिक जनसांख्यिकी पर कब्जा करें।",

  services_introservice2_point6:
    "तेजी से निर्णय लेने, निष्पादन और परिणाम के लिए विश्लेषण का उपयोग करें।",

  services_introservice1_content:
    "Civy शहरों, सरकारों और निवासियों के लिए एक जुड़ाव मंच है, और आपको अपना डेटा बनाने, एकत्र करने और संग्रहीत करने में सक्षम बनाता है।",

  services_introservice2_content:
    "Civy नागरिक जुड़ाव को बढ़ावा देने के लिए एक आसान उपयोग मंच प्रदान करता है।",

  // about page

  about_history1_title: "विचार",

  about_history1_content:
    "दुनिया भर में बुनियादी ढांचे, ऊर्जा और प्रौद्योगिकी पर केंद्रित कई परियोजनाओं को निष्पादित करने के बाद, हमने महसूस किया कि सरकारों, शहरों के अधिकारियों और समुदायों ने अपने सबसे अच्छे इरादों के बावजूद, हमेशा परामर्श की कमी की शिकायत की; जबकि डेवलपर्स जैसे निजी हितों को चिंता है कि यदि वे समुदायों के साथ बहुत अधिक जुड़ते हैं तो उनके वाणिज्यिक उद्देश्य नकारात्मक रूप से प्रभावित होंगे। दूसरी ओर समुदायों ने महसूस किया कि उन्हें चीनी-लेपित व्यापार योजनाएं और परियोजना निवेश प्रस्ताव प्रदान किए गए थे, लेकिन उन्हें डिजाइन चरण में परामर्श नहीं दिया जाता है या अक्सर गैर-विशेषज्ञों के रूप में व्यवहार किया जाता है जो यह नहीं जानते कि वे किस बारे में बात कर रहे हैं। निवासियों के लिए अपने समुदायों में नागरिक विकास परियोजनाओं के दौरान अनसुना महसूस करना एक सामान्य घटना है।",

  about_history2_title: "दीक्षा",

  about_history2_content:
    "इसे हल करने के लिए, हमने एक सामान्य मंच की कल्पना की, जहाँ परियोजना के विचारों को शहर और सरकारी अधिकारियों से प्राप्त किया जाता है, और सीधे प्रतिक्रिया के लिए निवासियों और हितधारकों को प्रस्तुत किया जाता है। पूर्व में हितधारकों (निवासियों) से प्रतिक्रिया के आधार पर कार्रवाई के सर्वोत्तम पाठ्यक्रम को संलग्न, विश्लेषण और संकीर्ण किया जा सकता है। सरकार और शहर के अधिकारी लोगों को सीधे समझा सकते हैं कि उनमें से क्या पूरा किया जा सकता है और क्या नहीं, संभावितों के साथ-साथ उन जटिलताओं को भी सूचीबद्ध करें, जो अल्पावधि में सामने आ सकती हैं, विकास में शामिल वित्तीयों को विस्तृत करें और उचित परामर्श से सभी सहयोगी कार्य करते हैं और परियोजनाओं को तेजी से लागू करते हैं।",

  about_history3_title: "निरूपण",

  about_history3_content:
    "स्पष्ट उद्देश्य और संकल्प के साथ, हमने शहरों और सरकारों (महापौर, काउंसिलर्स, विधान सभा, नगर प्रबंधक, विभाग के निदेशक, विपणन दल, प्रौद्योगिकी दल और सामुदायिक समूह) के साथ हमारे खोज चरण के दौरान दर्द-बिंदुओं को संबोधित करने पर ध्यान केंद्रित करते हुए अवधारणा मंच बनाया। व्यापक डिजिटल आउटरीच प्रदान करने और सभी नागरिक परियोजना के विकास के लिए निवासियों के साथ जुड़ने के लिए सोशल मीडिया पहलुओं के साथ सूचना विश्लेषिकी उपकरण के संयोजन वाले अवधारणा मंच ने ग्राहक सत्यापन प्राप्त किया है। मुख्य लक्ष्य समय, लागत और संसाधनों को कम करना था जो एक नागरिक परियोजना के निपटान में हैं और सार्वजनिक गोपनीयता को बढ़ाते हैं और डेटा गोपनीयता और सुरक्षा को बनाए रखते हुए सभी हितधारकों के लिए समावेशीता बढ़ाते हैं।",

  about_history4_title: "कार्यान्वयन",

  about_history4_content:
    "2019 से, हमने शहर और सरकारों को नागरिक परियोजनाओं में सुधार करने में मदद करने के लिए एक मंच प्लेटफ़ॉर्म सिवी को लागू किया। मंच सभी निवासियों की सहस्राब्दी से निवासियों को सभी जनसांख्यिकी के वरिष्ठ नागरिकों से उलझाकर प्रतिक्रिया देता है, इस तरह पुराने और विरासत तरीकों का उपयोग करने की आवश्यकता को कम करता है। पुराने जमाने के टाउनहॉल। मंच सभी परियोजनाओं के लिए हितधारकों को सीखने, संलग्न करने और एक ईमानदार प्रतिक्रिया प्रदान करने के लिए अभूतपूर्व सुविधा प्रदान करता है। मंच के कई सोशल मीडिया चैनलों, साइबर सुरक्षा और क्लाउड होस्टिंग समाधानों में एम्बेडेड एक-क्लिक शेयर भी डेटा गोपनीयता प्रदान करता है। बैक-ऑफिस उत्पादकता लाभ और शहरों और सरकारों को रणनीतिक सोच पर ध्यान केंद्रित करने में सक्षम बनाता है।",

  about_history_title: "नागरिक का इतिहास",

  about_history_since: "जबसे",

  about_vision_title: "हमारी दृष्टि",

  about_vision_content:
    "एक सगाई पाश बनाने के लिए जो शहरों, सरकारों, निवासियों, और हितधारकों को पकड़ता है, और एक स्मार्ट ग्रह का निर्माण करता है।",

  about_mission_title: "हमारा लक्ष्य",

  about_mission_content1:
    "Civy शहरों और सरकारों को अपने दर्द बिंदुओं को समझने, समझने और सुधारने में मदद करने के लिए नागरिक परियोजनाओं में सार्वजनिक आउटरीच और हितधारक जुड़ाव को बेहतर बनाने में मदद करता है और हमारे मालिकाना मंच का उपयोग करके बेहतर चर्चा को सुविधाजनक बनाने में मदद करता है। इसे पूरा करने के लिए हमारा दर्शन लोगों से पूछने, उनकी प्रतिक्रिया सुनने और हमारे ग्राहकों (शहरों और सरकारों) को इस प्रतिक्रिया पर काम करने के लिए एक-बैक-टू-बेसिक्स ’दृष्टिकोण है।",

  about_interview_title: "साक्षात्कार",

  about_interview_content:
    "अमर फ्लोरा, सिवी के संस्थापक को सिवी और शहरों और सरकारों की मदद करने के अपने लक्ष्य पर चर्चा करने के लिए लाइव टीवी पर साक्षात्कार दिया गया था",

  about_interview_maincontent:
    "देखो सिवी के संस्थापक अमर फ्लोरा लाइव टेलीविज़न पर बताते हैं कि कैसे सिवी निर्णयकर्ताओं को उपयोगकर्ताओं से डेटा का उपयोग तेजी से निर्णय लेने, बुद्धिमत्ता पर कार्य करने और अपने निवासियों के साथ-ब्लू-स्काई ’की सोच में जुड़ने में सक्षम बनाता है; सभी वास्तविक समय में, अनफ़िल्टर्ड और एक स्वतंत्र मंच पर।",

  about_ourteam_title: "हमारी टीम",

  about_ourteam_content:
    "हम GovTech, स्मार्ट सिटीज और स्टेकहोल्डर एंगेजमेंट के प्रति उत्साही लोगों के समूह हैं।",

  about_ourteam_person1_name: "अमर फ्लोरा (MBA, GAICD, GCCM, CPA)",

  about_ourteam_person1_title: "सह-संस्थापक और सीईओ",

  about_ourteam_person1_content:
    "एक दूरदर्शी नेता और उच्च शिक्षा, स्मार्ट शहरों और सरकारी कार्यों के लिए एक जुनून के साथ एक उद्यमी। अमर ने दो निजी स्वामित्व वाले स्टार्टअप की स्थापना की, वैश्विक टीमों और सहयोगियों का निर्माण किया, बोर्डों पर सेवा की, और $ 20M के निजी वित्त पोषण के साथ विश्वविद्यालय स्टार्टअप की स्थापना और संचालन का नेतृत्व किया। अमर ने विभिन्न उद्योगों में ग्राहकों के साथ सेवाएं बेचीं और परामर्श दिया, जिससे सार्थक प्रभाव और मूल्य निर्माण हुआ। अमर के पास रणनीतिक और परिचालन अवसरों की पहचान करने और नवाचार को चलाने की गहरी क्षमता है। अमर के पास एमबीए, पोस्ट-ग्रेजुएट्स इन चेंज मैनेजमेंट एंड कॉर्पोरेट गवर्नेंस, और यूएसए और ऑस्ट्रेलिया में शीर्ष संस्थानों से सीपीए प्रमाणन है।",

  about_ourteam_person2_name: "सबरीना उप्पल (एमएस, पीएमपी)",

  about_ourteam_person2_title: "सह-संस्थापक और सीओओ",

  about_ourteam_person2_content:
    "सबरीना Civy को गुणवत्ता के अनुभवों से जोड़ती है, और निजी और सरकारी क्षेत्रों में कई स्टार्टअप और अनुसंधान परियोजनाओं को सफलतापूर्वक निष्पादित कर रही है। अभिनव मानसिकता के साथ उनका रचनात्मक स्वभाव, उन्हें ग्राहकों के लिए डिजाइन और मूल्य प्रदान करने में सक्षम बनाता है। इसके अतिरिक्त, सबरीना अमेरिकी रक्षा विभाग द्वारा अनुबंधित संगठनों के लिए सरकारी अनुबंधों के प्रबंधन में व्यापक अनुभव रखती हैं। सबरीना के पास अपने शहर या सरकारी एजेंसी को एक परिणाम प्राप्त करने के लिए संलग्न करने का प्रयास करने का पहला अनुभव है। ये अनुभव शहरों और सरकारों को निवासियों के साथ उच्च प्रभाव वाली सगाई को बढ़ावा देने में मदद करने के लिए उसके जुनून और रचनात्मकता को चलाते हैं। सबरीना ने विज्ञान स्नातक, यू.सी. से न्यूरोसाइंस किया। डेविस; मास्टर ऑफ साइंस, कैल स्टेट नॉर्थ्रिज से जीव विज्ञान और पीएमपी प्रमाणित है।",

  about_ourteam_person3_name: "जिनहंग झांग (सीपीए, एमबीए, सीजीएमए)",

  about_ourteam_person3_title: "सीएफओ",

  about_ourteam_person3_content:
    "Jinhong जांग के पास व्यवसाय और वित्तीय नियोजन और प्रबंधन, अध्यक्ष सीएफओ, वित्त निदेशक के रूप में सेवारत भूमिका, और उद्यमी संगठनों में बड़े पैमाने पर सलाहकार के रूप में 20 से अधिक वर्षों का अनुभव है। जिनहोंग ने अपने करियर की शुरुआत फॉर्च्यून ग्लोबल 500 कंपनी के साथ की, जहां उन्होंने वर्ल्ड बैंक और एशिया डेवलपमेंट द्वारा वित्तपोषित और प्रत्येक पक्ष में पीडब्लूसी और केपीएमजी के साथ ऑडिटिंग और टैक्स एंगेजमेंट के लिए परियोजनाओं का प्रबंधन किया।",

  about_ourteam_person4_name: "सुकेतु मोदी",

  about_ourteam_person4_title: "सीटीओ",

  about_ourteam_person4_content: `फोर्ब्स इंडिया द्वारा भारत के 100 महान लोगों के बीच 2019 में मान्यता प्राप्त है, और शहरों के लिए बेस्ट इन्फ्रास्ट्रक्चर डिजाइनिंग और स्मार्ट ई-गवर्नेंस से सम्मानित किया गया है, सुकेतु एक अनुभवी व्यवसाय नेता और तकनीकी विशेषज्ञ है, जो शीर्ष बहुराष्ट्रीय परामर्श फर्मों, सरकारों, और आईसीटी से परामर्श कर रहा है। PSUs जो Civy के लिए CTO के रूप में कार्य करते हैं। सुकेतु के पास आईसीटी इन्फ्रास्ट्रक्चर नेटवर्क इन्फ्रास्ट्रक्चर और स्मार्ट सर्विसेज डिजाइनिंग के 19+ साल के आईसीटी कंसल्टिंग और इंप्लीमेंटेशन का अनुभव है। सुकेतु ने अमेरिका, मध्य पूर्व, सिंगापुर और भारत के ग्राहकों और ग्राहकों के साथ काम किया है।`,

  about_ourteam_description1:
    "हम शहरों और सरकारों को निवासियों की बेहतरी के लिए नवाचार को बढ़ावा देने में मदद करने के बारे में भावुक हैं।",

  about_ourteam_description2:
    "Civy के लिए एक विशेष भागीदार, Infixzon कई दशकों के अनुभव के साथ उद्योग के दिग्गजों के नेतृत्व में एक परामर्श, क्लाउड और साइबर सुरक्षा सेवा कंपनी है। Infixzon यूएसए, एपीएसी और मिड-ईस्ट क्षेत्रों में कार्य करता है, जो सार्वजनिक क्षेत्र, हेल्थकेयर, वित्तीय सेवाओं, फार्मास्यूटिकल्स और विनिर्माण जैसे ऊर्ध्वाधर के लिए समाधान तैयार करता है।",

  about_ourteam_description3:
    "ट्विश टेक्नोलॉजीज बुनियादी ढांचा नीतियों, परियोजना व्यवहार्यता अध्ययन, शहर स्तर के बुनियादी ढांचे, स्मार्ट समुदायों और स्मार्ट शहरों के लिए एकीकरण और कार्यान्वयन रणनीति में नेतृत्व के वर्षों के साथ पेशेवरों की एक टीम है। उनकी टीम में शहरों और सरकारों की ओर से सामुदायिक सहभागिता पर केंद्रित एक संगठनात्मक मनोवैज्ञानिक शामिल है।",

  //Terms and conditions page

  ourpolicies_term_of_use_title: "उपयोग की शर्तें",

  ourpolicies_terms_title: "नियम और शर्तें",

  ourpolicies_terms_last_updated: "अंतिम अद्यतन: {day} {month}, {year}",

  ourpolicies_terms_content1: `इन नियमों और शर्तों ("नियम", "नियम और शर्तें") को https://www.civy.co वेबसाइट और सिवी मोबाइल एप्लिकेशन (एक साथ, या व्यक्तिगत रूप से, "सेवा") को सिवि द्वारा संचालित करने से पहले ध्यान से पढ़ें। इंक ("हम", "हम", या "हमारे")।`,

  ourpolicies_terms_content2:
    "सेवा की आपकी पहुंच और उपयोग इन शर्तों के साथ आपकी स्वीकृति और अनुपालन पर वातानुकूलित है। ये शर्तें उन सभी आगंतुकों, उपयोगकर्ताओं और अन्य लोगों के लिए लागू होती हैं जो सेवा तक पहुँच या उपयोग करना चाहते हैं।",

  ourpolicies_terms_content3:
    "सेवा तक पहुँचने या उपयोग करने से आप इन शर्तों से बंधे होने के लिए सहमत होते हैं। यदि आप शर्तों के किसी भाग से असहमत हैं तो आपके पास सेवा तक पहुँचने की अनुमति नहीं है।",

  ourpolicies_terms_Communications_title: "संचार",

  ourpolicies_terms_Communications_content1:
    "हमारी सेवा पर एक खाता बनाने से, आप न्यूज़लेटर्स, मार्केटिंग या प्रचार सामग्री और अन्य सूचनाओं की सदस्यता लेने के लिए सहमत होते हैं जो हम भेज सकते हैं। हालाँकि, आप किसी भी, या सभी के इन संचारों को अनसब्सक्राइब लिंक या किसी ईमेल द्वारा भेजे गए निर्देशों में दिए गए निर्देशों का पालन करके प्राप्त कर सकते हैं।",

  ourpolicies_terms_subscription_title: "सदस्यता",

  ourpolicies_terms_subscription_content1: `सेवा के कुछ हिस्सों को सदस्यता के आधार ("सदस्यता (ओं)") पर बिल दिया जाता है। आपको एक आवर्ती और आवधिक आधार ("बिलिंग साइकिल") पर अग्रिम रूप से बिल दिया जाएगा। बिलिंग चक्र या तो मासिक या वार्षिक आधार पर निर्धारित किए जाते हैं, जो कि सदस्यता खरीदते समय आपके द्वारा चयनित सदस्यता योजना के प्रकार पर निर्भर करता है।`,

  ourpolicies_terms_subscription_content2:
    "प्रत्येक बिलिंग चक्र के अंत में, आपकी सदस्यता स्वचालित रूप से सटीक समान शर्तों के तहत नवीनीकृत हो जाएगी जब तक कि आप इसे रद्द नहीं करते या Civy Inc इसे रद्द नहीं करता। आप अपने ऑनलाइन खाता प्रबंधन पृष्ठ के माध्यम से या Civy Inc ग्राहक सहायता टीम से संपर्क करके अपना सदस्यता नवीनीकरण रद्द कर सकते हैं।",

  ourpolicies_terms_subscription_content3:
    "क्रेडिट कार्ड या पेपाल सहित एक वैध भुगतान विधि, आपके सब्सक्रिप्शन के भुगतान को संसाधित करने के लिए आवश्यक है। आपको पूर्ण नाम, पता, राज्य, ज़िप कोड, टेलीफोन नंबर और एक मान्य भुगतान विधि जानकारी सहित सटीक और पूर्ण बिलिंग जानकारी प्रदान की जाएगी। इस तरह की भुगतान जानकारी सबमिट करके, आप स्वचालित रूप से Civy Inc को अपने खाते से होने वाली सभी सदस्यता शुल्क को ऐसे किसी भी भुगतान उपकरण पर लगाने के लिए अधिकृत करते हैं।",

  ourpolicies_terms_subscription_content4:
    "किसी भी कारण से स्वत: बिलिंग विफल होना चाहिए, सिवी इंक एक इलेक्ट्रॉनिक चालान जारी करेगा जो यह दर्शाता है कि आपको एक निश्चित समय सीमा के भीतर मैन्युअल रूप से आगे बढ़ना होगा, चालान पर संकेत दिए गए बिलिंग अवधि के अनुरूप पूर्ण भुगतान।",

  ourpolicies_terms_feechanges_title: "शुल्क परिवर्तन",

  ourpolicies_terms_feechanges_content1:
    "Civy Inc, अपने एकमात्र विवेक और किसी भी समय, सदस्यता के लिए सदस्यता शुल्क को संशोधित कर सकता है। कोई सदस्यता शुल्क परिवर्तन तत्कालीन वर्तमान बिलिंग चक्र के अंत में प्रभावी हो जाएगा।",

  ourpolicies_terms_feechanges_content2:
    "Civy Inc आपको सब्सक्रिप्शन शुल्क में किसी भी तरह के बदलाव का एक उचित पूर्व सूचना प्रदान करेगा ताकि आपको इस तरह के बदलाव प्रभावी होने से पहले अपने सब्सक्रिप्शन को समाप्त करने का अवसर मिल सके।",

  ourpolicies_terms_feechanges_content3:
    "सदस्यता शुल्क परिवर्तन प्रभावी होने के बाद सेवा का आपका निरंतर उपयोग संशोधित सदस्यता शुल्क राशि का भुगतान करने के लिए आपके समझौते का गठन करता है।",

  ourpolicies_terms_refund_title: "रिफंड",

  ourpolicies_terms_refund_content:
    "कानून द्वारा आवश्यक होने पर, भुगतान की गई सदस्यता शुल्क गैर-वापसी योग्य हैं।",

  ourpolicies_terms_content_title: "सामग्री",

  ourpolicies_terms_content_description1: `हमारी सेवा आपको पोस्ट, लिंक, स्टोर, शेयर और अन्यथा कुछ निश्चित जानकारी, पाठ, ग्राफिक्स, वीडियो या अन्य सामग्री ("सामग्री") उपलब्ध कराने की अनुमति देती है। आप उस सामग्री के लिए ज़िम्मेदार हैं, जिसे आप उसकी वैधता, विश्वसनीयता और उपयुक्तता सहित, सेवा के माध्यम से या उसके माध्यम से पोस्ट करते हैं।`,

  ourpolicies_terms_content_description2:
    "सेवा पर या उसके माध्यम से सामग्री पोस्ट करके, आप यह दर्शाते हैं और कि: (i) सामग्री आपकी (आप स्वयं की है) और / या आपको इसका उपयोग करने का अधिकार है और हमें दिए गए अधिकार और लाइसेंस प्रदान करने का अधिकार है इन शर्तों, और (ii) कि सेवा पर या उसके माध्यम से आपकी सामग्री की पोस्टिंग किसी व्यक्ति या संस्था के गोपनीयता अधिकारों, प्रचार अधिकारों, कॉपीराइट, अनुबंध अधिकारों या किसी अन्य अधिकार का उल्लंघन नहीं करती है। हम कॉपीराइट पर उल्लंघन करने वाले पाए गए किसी भी व्यक्ति के खाते को समाप्त करने का अधिकार सुरक्षित रखते हैं।",

  ourpolicies_terms_content_description3:
    "आप सेवा के माध्यम से या उसके माध्यम से अपने द्वारा सबमिट की गई किसी भी सामग्री को अपने किसी भी और सभी अधिकारों को बरकरार रखते हैं, और आप उन अधिकारों की रक्षा के लिए जिम्मेदार हैं। हम कोई जिम्मेदारी नहीं लेते हैं और सेवा के माध्यम से या आपके माध्यम से सामग्री के लिए या किसी भी तीसरे पक्ष के पदों के लिए कोई दायित्व नहीं मानते हैं। हालाँकि, सेवा का उपयोग करके सामग्री पोस्ट करके आप हमें इस तरह की सामग्री का उपयोग करने, संशोधित करने, प्रदर्शन, प्रदर्शन, पुन: प्रस्तुत करने और वितरित करने का अधिकार और लाइसेंस प्रदान करते हैं।",

  ourpolicies_terms_content_description4:
    "Civy Inc का अधिकार है लेकिन उपयोगकर्ताओं द्वारा प्रदान की गई सभी सामग्री की निगरानी और संपादन करने का दायित्व नहीं है।",

  ourpolicies_terms_content_description5:
    "इसके अलावा, इस सेवा पर या इसके माध्यम से मिलने वाली सामग्री Civy Inc की संपत्ति है या अनुमति के साथ उपयोग की जाती है। हमारे द्वारा लिखित अग्रिम अनुमति के बिना, व्यावसायिक उद्देश्यों के लिए या व्यक्तिगत लाभ के लिए, पूर्ण या आंशिक रूप में, चाहे आप सामग्री का वितरण, संशोधन, पुन: उपयोग, डाउनलोड, पुनर्निवेश, प्रतिलिपि, या उपयोग न करें।",

  ourpolicies_terms_account_title: "हिसाब किताब",

  ourpolicies_terms_account_content1:
    "जब आप हमारे साथ एक खाता बनाते हैं, तो आप गारंटी देते हैं कि आप 18 वर्ष की आयु से ऊपर हैं, और यह कि आप हमें जो जानकारी प्रदान करते हैं, वह हर समय सटीक, पूर्ण और चालू है। गलत, अधूरी या अप्रचलित जानकारी के परिणामस्वरूप आपका खाता सेवा में तत्काल समाप्त हो सकता है।",

  ourpolicies_terms_account_content2:
    "आप अपने खाते और पासवर्ड की गोपनीयता बनाए रखने के लिए ज़िम्मेदार हैं, लेकिन यह आपके कंप्यूटर और / या खाते तक पहुंच के प्रतिबंध तक सीमित नहीं है। आप अपने खाते और / या पासवर्ड के तहत होने वाली किसी भी और सभी गतिविधियों या कार्यों के लिए जिम्मेदारी स्वीकार करने के लिए सहमत हैं, चाहे आपका पासवर्ड हमारी सेवा या तीसरे पक्ष की सेवा के साथ हो। किसी भी सुरक्षा के उल्लंघन या आपके खाते के अनधिकृत उपयोग से अवगत होने पर आपको तुरंत हमें सूचित करना चाहिए।",

  ourpolicies_terms_account_content3:
    "आप एक उपयोगकर्ता नाम के रूप में किसी अन्य व्यक्ति या संस्था के नाम का उपयोग नहीं कर सकते हैं या जो कि वैध रूप से उपयोग के लिए उपलब्ध नहीं है, एक नाम या ट्रेडमार्क जो आपके लिए उपयुक्त प्राधिकरण के बिना किसी अन्य व्यक्ति या इकाई के किसी भी अधिकार के अधीन है। आप एक उपयोगकर्ता नाम के रूप में किसी भी नाम का उपयोग नहीं कर सकते हैं जो अपमानजनक, अशिष्ट या अश्लील है।",

  ourpolicies_terms_Intellectual_title: "बौद्धिक सम्पदा",

  ourpolicies_terms_Intellectual_content1:
    "सेवा और इसकी मूल सामग्री (उपयोगकर्ताओं द्वारा प्रदान की गई सामग्री को छोड़कर), सुविधाएँ और कार्यक्षमता हैं और सिवी इंक और उसके लाइसेंसकर्ताओं की अनन्य संपत्ति रहेगी। सेवा कॉपीराइट, ट्रेडमार्क, और संयुक्त राज्य अमेरिका और विदेशों दोनों के अन्य कानूनों द्वारा संरक्षित है। हमारे ट्रेडमार्क और ट्रेड ड्रेस का उपयोग सिवी इंक की पूर्व लिखित सहमति के बिना किसी भी उत्पाद या सेवा के संबंध में नहीं किया जा सकता है।",

  ourpolicies_terms_links_title: "अन्य वेब साइटों के लिंक",

  ourpolicies_terms_links_content1:
    "हमारी सेवा में तृतीय पक्ष की वेब साइट या सेवाओं के लिंक हो सकते हैं जो सिवी इंक के स्वामित्व या नियंत्रण में नहीं हैं",

  ourpolicies_terms_links_content2:
    "सिवी इंक का कोई नियंत्रण नहीं है, और यह किसी भी तीसरे पक्ष की वेब साइटों या सेवाओं की सामग्री, गोपनीयता नीतियों, या प्रथाओं के लिए कोई जिम्मेदारी नहीं मानता है। हम इन संस्थाओं / व्यक्तियों या उनकी वेबसाइटों में से किसी के प्रसाद का वारंट नहीं करते हैं।",

  ourpolicies_terms_links_content3:
    "आप स्वीकार करते हैं और सहमत हैं कि Civy Inc किसी भी ऐसी सामग्री, सामान या सेवाओं के उपयोग या उस पर निर्भर या उपयोग के संबंध में या उसके कारण होने वाली किसी भी क्षति या हानि के लिए प्रत्यक्ष या अप्रत्यक्ष रूप से जिम्मेदार या उत्तरदायी नहीं होगा। ऐसी कोई भी तृतीय पक्ष वेब साइट या सेवाएं।",

  ourpolicies_terms_links_content4:
    "हम आपको दृढ़ता से सलाह देते हैं कि आप किसी भी तृतीय पक्ष की वेब साइटों या सेवाओं की शर्तों और गोपनीयता नीतियों को पढ़ें।",

  ourpolicies_terms_termination_title: "समाप्ति",

  ourpolicies_terms_termination_content1:
    "हम बिना किसी कारण और बिना किसी सीमा के या बिना किसी सीमा के, बिना किसी पूर्व सूचना या देयता के, बिना किसी पूर्व सूचना या दायित्व के, तुरंत आपके खाते और बार की सेवा को समाप्त या निलंबित कर सकते हैं।",

  ourpolicies_terms_termination_content2:
    "यदि आप अपना खाता समाप्त करना चाहते हैं, तो आप बस सेवा का उपयोग बंद कर सकते हैं।",

  ourpolicies_terms_termination_content3:
    "शर्तों के सभी प्रावधान जो उनकी प्रकृति द्वारा समाप्त होने से बचना चाहिए, बिना किसी सीमा के, समाप्ति, स्वामित्व प्रावधानों, वारंटी अस्वीकरण, क्षतिपूर्ति और देयता की सीमाओं सहित समाप्ति तक जीवित रहेंगे।",

  ourpolicies_terms_Indemnification_title: "प्रीमियम",

  ourpolicies_terms_Indemnification_content1:
    "आप किसी भी और सभी दावों, हर्जाना, दायित्वों, नुकसान, देनदारियों, लागतों या ऋण, और ऋण के खिलाफ, बचाव और क्षतिपूर्ति करने के लिए सहमत हैं, और हानिरहित सिवी इंक और उसके लाइसेंसधारी और लाइसेंसधारियों, और उनके कर्मचारियों, ठेकेदारों, एजेंटों, अधिकारियों और निदेशकों को सहमत हैं। व्यय (सहित, लेकिन वकील की फीस तक सीमित नहीं), जिसके परिणामस्वरूप या उत्पन्न होता है) आपका उपयोग और सेवा का उपयोग, आपके या किसी व्यक्ति द्वारा आपके खाते और पासवर्ड का उपयोग करके; b) इन शर्तों का उल्लंघन, या c) सेवा पर पोस्ट की गई सामग्री।",

  ourpolicies_terms_limitation_title: "दायित्व की सीमा",

  ourpolicies_terms_limitation_content1:
    "किसी भी घटना में Civy Inc, और न ही इसके निदेशक, कर्मचारी, भागीदार, एजेंट, आपूर्तिकर्ता या सहयोगी, किसी भी अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी या दंडात्मक नुकसान के लिए उत्तरदायी नहीं होंगे, जिसमें सीमा, लाभ हानि, डेटा, उपयोग, सद्भावना शामिल हैं। , या अन्य अमूर्त नुकसान, से उत्पन्न",

  ourpolicies_terms_limitation_list1:
    "सेवा तक पहुँचने या उपयोग करने में आपकी अक्षमता या उपयोग की अक्षमता",

  ourpolicies_terms_limitation_list2:
    "सेवा पर किसी तीसरे पक्ष का कोई आचरण या सामग्री",

  ourpolicies_terms_limitation_list3: "सेवा से प्राप्त कोई भी सामग्री",

  ourpolicies_terms_limitation_list4:
    "आपके प्रसारण या सामग्री का अनधिकृत उपयोग, उपयोग या परिवर्तन, चाहे वह वारंटी, अनुबंध, यातना (लापरवाही सहित) या किसी अन्य कानूनी सिद्धांत पर आधारित हो, भले ही हमें इस तरह के नुकसान की संभावना के बारे में सूचित किया गया हो या नहीं, और भले ही कोई उपाय निर्धारित किया गया हो। इसके आगे यह पाया गया है कि यह अपने आवश्यक उद्देश्य में विफल रहा है।",

  ourpolicies_terms_disclaimer_title: "अस्वीकरण",

  ourpolicies_terms_disclaimer_content1:
    'सेवा का आपका उपयोग आपके एकमात्र जोखिम पर है। सेवा "AS IS" और "AS उपलब्ध" आधार पर प्रदान की जाती है। सेवा किसी भी प्रकार की वारंटी के बिना प्रदान की जाती है, चाहे व्यक्त या निहित, सहित, लेकिन सीमित नहीं है, निहित योग्यता की वारंटी, किसी विशेष उद्देश्य के लिए फिटनेस, गैर-उल्लंघन या प्रदर्शन का कोर्स।',

  ourpolicies_terms_disclaimer_content2:
    "Civy Inc इसकी सहायक कंपनियों, सहयोगी कंपनियों, और इसके लाइसेंसधारियों के लिए वारंट नहीं है",

  ourpolicies_terms_disclaimer_list1:
    "सेवा किसी भी विशेष समय या स्थान पर निर्बाध, सुरक्षित या उपलब्ध कार्य करेगी",

  ourpolicies_terms_disclaimer_list2: "किसी भी त्रुटि या दोष को ठीक किया जाएगा",

  ourpolicies_terms_disclaimer_list3:
    "सेवा वायरस या अन्य हानिकारक घटकों से मुक्त है",

  ourpolicies_terms_disclaimer_list4:
    "सेवा का उपयोग करने के परिणाम आपकी आवश्यकताओं को पूरा करेंगे।",

  ourpolicies_terms_exclusion_title: "बहिष्करण",

  ourpolicies_terms_exclusion_content1:
    "कुछ न्यायालय कुछ वारंटियों के बहिष्करण या परिणामी या आकस्मिक नुकसान के लिए दायित्व के बहिष्करण या सीमा को अनुमति नहीं देते हैं, इसलिए उपरोक्त सीमाएं आपके लिए लागू नहीं हो सकती हैं।",

  ourpolicies_terms_governing_title: "शासकीय कानून",

  ourpolicies_terms_governing_content1:
    "इन नियमों को कैलिफोर्निया, संयुक्त राज्य अमेरिका के कानून के प्रावधानों के टकराव के संबंध के बिना शासित और माना जाएगा।",

  ourpolicies_terms_governing_content2:
    "इन शर्तों के किसी भी अधिकार या प्रावधान को लागू करने में हमारी विफलता को उन अधिकारों की छूट नहीं माना जाएगा। यदि इन शर्तों के किसी प्रावधान को अदालत द्वारा अमान्य या अप्रवर्तनीय माना जाता है, तो इन शर्तों के शेष प्रावधान प्रभावी रहेंगे। ये शर्तें हमारी सेवा के बारे में हमारे बीच पूरे समझौते का निर्माण करती हैं, और सेवा के संबंध में हमारे बीच हुए किसी भी पूर्व समझौतों की जगह ले सकती हैं।",

  ourpolicies_terms_changes_title: "परिवर्तन",

  ourpolicies_terms_changes_content1:
    "हम किसी भी समय इन शर्तों को संशोधित या बदलने के लिए, अपने एकमात्र विवेक पर अधिकार सुरक्षित रखते हैं। यदि कोई संशोधन होता है तो हम किसी भी नई शर्तों को लागू करने से पहले कम से कम 30 दिन का नोटिस देंगे। हमारे एकमात्र विवेक पर एक सामग्री परिवर्तन का गठन किया जाएगा।",

  ourpolicies_terms_changes_content2:
    "किसी भी संशोधन के प्रभावी होने के बाद हमारी सेवा का उपयोग या उपयोग जारी रखने से, आप संशोधित शर्तों से बाध्य होने के लिए सहमत होते हैं। यदि आप नई शर्तों से सहमत नहीं हैं, तो आप सेवा का उपयोग करने के लिए अधिकृत नहीं हैं।",

  ourpolicies_terms_contactus_title: "संपर्क करें",

  ourpolicies_terms_contactus_content:
    "यदि आपके पास इन शर्तों के बारे में कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें",

  //Privacy policies page

  ourpolicies_policy_title: "गोपनीयता नीति",

  ourpolicies_policy_date: "प्रभावी तिथि: {day} {month}, {year}",

  ourpolicies_policy_content1: `Civy Inc. ("हमें", "हम", या "हमारे") https://www.civy.co संचालित करता है
    वेबसाइट और सिवी मोबाइल एप्लिकेशन (इसके बाद के रूप में जाना जाता है
    "सेवा")। `,

  ourpolicies_policy_content2:
    " जब आप हमारी सेवा और उस डेटा से जुड़े विकल्पों का उपयोग करते हैं, तो यह पृष्ठ आपको व्यक्तिगत डेटा के संग्रह, उपयोग और प्रकटीकरण के बारे में हमारी नीतियों से अवगत कराता है।",

  ourpolicies_policy_content3:
    " हम सेवा प्रदान करने और सुधारने के लिए आपके डेटा का उपयोग करते हैं। सेवा का उपयोग करके आप इस नीति के अनुसार जानकारी के संग्रह और उपयोग के लिए सहमत होते हैं। जब तक इस गोपनीयता नीति में परिभाषित अन्य बातें, इस गोपनीयता नीति में उपयोग किए गए शब्द हमारे नियम और शर्तों के समान हैं।",

  ourpolicies_definitions_title: "परिभाषाएं",

  ourpolicies_service_title: "सर्विस",

  ourpolicies_service_content: `सेवा का अर्थ है https://www.civy.co वेबसाइट और सिवी मोबाइल सिवी इंक द्वारा संचालित आवेदन`,

  ourpolicies_personaldata_title: "व्यक्तिगत डेटा",

  ourpolicies_personaldata_content:
    "व्यक्तिगत डेटा का अर्थ है एक जीवित व्यक्ति के बारे में डेटा, जो उन डेटा (या उन लोगों से और अन्य जानकारी या तो हमारे अधिकार में आने की संभावना है) से पहचाना जा सकता है।",

  ourpolicies_usagedata_title: "डेटा का उपयोग",

  ourpolicies_usagedata_content:
    "उपयोग डेटा स्वचालित रूप से या तो सेवा के उपयोग से या सेवा के बुनियादी ढांचे से उत्पन्न डेटा एकत्र किया जाता है (उदाहरण के लिए, पृष्ठ की यात्रा की अवधि)।",

  ourpolicies_cookie_title: "कुकीज़",

  ourpolicies_cookie_content:
    "कुकीज़ आपके डिवाइस (कंप्यूटर या मोबाइल डिवाइस) पर संग्रहीत छोटी फाइलें हैं।",

  ourpolicies_datacontroller_title: "डेटा नियंत्रक",

  ourpolicies_datacontroller_content1:
    "डेटा नियंत्रक का अर्थ है प्राकृतिक या कानूनी व्यक्ति जो (या तो अकेले या संयुक्त रूप से या अन्य व्यक्तियों के साथ आम तौर पर) उन उद्देश्यों को निर्धारित करता है जिनके लिए और जिस तरीके से कोई व्यक्तिगत जानकारी होती है, या संसाधित होने वाली होती है।",

  ourpolicies_datacontroller_content2:
    "इस गोपनीयता नीति के उद्देश्य के लिए, हम आपके व्यक्तिगत डेटा के डेटा नियंत्रक हैं।",

  ourpolicies_dataprocessor_title: "डेटा प्रोसेसर (या सेवा प्रदाता)",

  ourpolicies_dataprocessor_content1:
    "डेटा प्रोसेसर (या सेवा प्रदाता) का अर्थ किसी भी प्राकृतिक या कानूनी व्यक्ति से है जो डेटा नियंत्रक की ओर से डेटा को संसाधित करता है।",

  ourpolicies_dataprocessor_content2:
    "आपके डेटा को अधिक प्रभावी ढंग से संसाधित करने के लिए हम विभिन्न सेवा प्रदाताओं की सेवाओं का उपयोग कर सकते हैं।",

  ourpolicies_datasubject_title: "डेटा विषय (या उपयोगकर्ता)",

  ourpolicies_datasubject_content:
    "डेटा विषय कोई भी जीवित व्यक्ति है जो हमारी सेवा का उपयोग कर रहा है और व्यक्तिगत डेटा का विषय है।",

  ourpolicies_information_title: "सूचना संग्रह और उपयोग",

  ourpolicies_information_content:
    "हम आपको अपनी सेवा प्रदान करने और बेहतर बनाने के लिए विभिन्न उद्देश्यों के लिए कई विभिन्न प्रकार की जानकारी एकत्र करते हैं।",

  ourpolicies_typeofdata_title: "डेटा एकत्र के प्रकार",

  ourpolicies_typeofdata_personal_title: "व्यक्तिगत डेटा",

  ourpolicies_typeofdata_personal_content1: `हमारी सेवा का उपयोग करते समय, हम आपसे कुछ निश्चित करने के लिए कह सकते हैं व्यक्तिगत रूप से पहचान योग्य जानकारी जिसका उपयोग संपर्क करने या करने के लिए किया जा सकता है आप पहचान ("व्यक्तिगत डेटा")। व्यक्तिगत रूप से पहचान योग्य जानकारी हो सकती है शामिल हैं, लेकिन यह तक सीमित नहीं है:`,

  ourpolicies_typeofdata_personal_list1: `ईमेल पता`,

  ourpolicies_typeofdata_personal_list2: `पहला नाम और अंतिम नाम`,

  ourpolicies_typeofdata_personal_list3: `फ़ोन नंबर`,

  ourpolicies_typeofdata_personal_list4: `पता, राज्य, प्रांत, ज़िप / पोस्टल कोड, शहर`,

  ourpolicies_typeofdata_personal_list5: `कुकीज़ और उपयोग डेटा `,

  ourpolicies_typeofdata_personal_content2: `हम समाचार पत्रों, विपणन या प्रचार सामग्री और अन्य जानकारी के लिए आपसे संपर्क करने के लिए आपके व्यक्तिगत डेटा का उपयोग कर सकते हैं, जो आपके लिए रुचि हो सकती है। आप अनसब्सक्राइब लिंक या हमारे द्वारा भेजे गए किसी भी ईमेल में दिए गए निर्देशों का पालन करके, हमसे कोई भी, या इन सभी संचार प्राप्त करने का विकल्प चुन सकते हैं।`,

  ourpolicies_typeofdata_usage_title: `डेटा का उपयोग`,

  ourpolicies_typeofdata_usage_content1: `हम यह भी जानकारी एकत्र कर सकते हैं कि आपका ब्राउज़र जब भी आप हमारी सेवा पर जाते हैं या जब आप सेवा का उपयोग मोबाइल डिवाइस ("उपयोग डेटा") के माध्यम से करते हैं।`,

  ourpolicies_typeofdata_usage_content2: `इस उपयोग डेटा में आपके कंप्यूटर का इंटरनेट प्रोटोकॉल पता (जैसे IP पता), ब्राउज़र प्रकार, ब्राउज़र संस्करण, हमारी सेवा के पृष्ठ जो आप आते हैं, आपकी यात्रा का समय और तारीख, उन पृष्ठों पर बिताया गया समय, अद्वितीय जैसी जानकारी शामिल हो सकती है। डिवाइस पहचानकर्ता और अन्य नैदानिक ​​डेटा।`,

  ourpolicies_typeofdata_usage_content3: `जब आप मोबाइल डिवाइस के साथ सेवा का उपयोग करते हैं, तो इस उपयोग डेटा में आपके द्वारा उपयोग किए जाने वाले मोबाइल डिवाइस के प्रकार, आपके मोबाइल डिवाइस की अनन्य ID, आपके मोबाइल डिवाइस का IP पता, आपके मोबाइल ऑपरेटिंग सिस्टम, मोबाइल इंटरनेट का प्रकार जैसी जानकारी शामिल हो सकती है। आपके द्वारा उपयोग किया जाने वाला ब्राउज़र, अद्वितीय उपकरण पहचानकर्ता और अन्य नैदानिक ​​डेटा।`,

  ourpolicies_typeofdata_location_title: `जगह की जानकारी`,

  ourpolicies_typeofdata_location_content1: `यदि आप हमें ऐसा करने की अनुमति देते हैं तो हम आपके स्थान के बारे में जानकारी का उपयोग और संग्रह कर सकते हैं ("स्थान डेटा")। हम इस डेटा का उपयोग अपनी सेवा की सुविधाओं को प्रदान करने, अपनी सेवा को बेहतर बनाने और अनुकूलित करने के लिए करते हैं।`,

  ourpolicies_typeofdata_location_content2: `जब आप हमारी सेवा का उपयोग किसी भी समय अपनी डिवाइस सेटिंग्स के माध्यम से कर सकते हैं, तो आप स्थान सेवाओं को सक्षम या अक्षम कर सकते हैं।`,

  ourpolicies_typeofdata_tracking_title: `ट्रैकिंग डेटा`,

  ourpolicies_typeofdata_tracking_content1: `हम अपनी सेवा पर गतिविधि को ट्रैक करने के लिए कुकीज़ और समान ट्रैकिंग तकनीकों का उपयोग करते हैं और हम कुछ जानकारी रखते हैं।`,

  ourpolicies_typeofdata_tracking_content2: `कुकीज़ एक छोटी मात्रा में डेटा वाली फाइलें होती हैं जिनमें एक अनाम विशिष्ट पहचानकर्ता शामिल हो सकता है। कुकीज़ एक वेबसाइट से आपके ब्राउज़र पर भेजी जाती हैं और आपके डिवाइस पर संग्रहीत होती हैं। अन्य ट्रैकिंग तकनीकों का भी उपयोग किया जाता है जैसे कि बीकन, टैग और स्क्रिप्ट जानकारी इकट्ठा करने और ट्रैक करने और हमारी सेवा में सुधार और विश्लेषण करने के लिए।`,

  ourpolicies_typeofdata_tracking_content3: `आप अपने ब्राउज़र को निर्देश दे सकते हैं कि सभी कुकीज़ को मना कर दें या इंगित करें कि कुकी कब भेजी जा रही है। हालाँकि, यदि आप कुकीज़ स्वीकार नहीं करते हैं, तो आप हमारी सेवा के कुछ भागों का उपयोग करने में सक्षम नहीं हो सकते हैं।`,

  ourpolicies_typeofdata_cookiesex_title: `कुकीज़ के उदाहरण हम उपयोग करते हैं:`,

  ourpolicies_typeofdata_cookiesex_session: "सत्र कुकीज़।",

  ourpolicies_typeofdata_cookiesex_session_content: `हम अपनी सेवा को संचालित करने के लिए सत्र कुकीज़ का उपयोग करते हैं।`,

  ourpolicies_typeofdata_cookiesex_preference: "पसंद कुकीज़।",

  ourpolicies_typeofdata_cookiesex_preference_content: `हम आपकी पसंद और विभिन्न सेटिंग्स को याद रखने के लिए वरीयता कुकीज़ का उपयोग करते हैं।`,

  ourpolicies_typeofdata_cookiesex_security: `सुरक्षा कुकीज़।`,

  ourpolicies_typeofdata_cookiesex_security_content: `हम सुरक्षा उद्देश्यों के लिए सुरक्षा कुकीज़ का उपयोग करते हैं।`,

  ourpolicies_typeofdata_use_title: `डेटा का उपयोग`,

  ourpolicies_typeofdata_use_content: `Civy Inc. विभिन्न उद्देश्यों के लिए एकत्रित डेटा का उपयोग करता है:`,

  ourpolicies_typeofdata_use_list1: `हमारी सेवा प्रदान करने और बनाए रखने के लिए`,

  ourpolicies_typeofdata_use_list2: `हमारी सेवा में परिवर्तनों के बारे में आपको सूचित करने के लिए`,

  ourpolicies_typeofdata_use_list3: `जब आप ऐसा करने के लिए चुनते हैं तो आपको हमारी सेवा की इंटरैक्टिव सुविधाओं में भाग लेने की अनुमति मिलती है`,

  ourpolicies_typeofdata_use_list4: `ग्राहक सहायता प्रदान करने के लिए`,

  ourpolicies_typeofdata_use_list5: `विश्लेषण या मूल्यवान जानकारी इकट्ठा करने के लिए ताकि हम अपनी सेवा में सुधार कर सकें`,

  ourpolicies_typeofdata_use_list8: `हमारी सेवा के उपयोग की निगरानी करना`,

  ourpolicies_typeofdata_use_list6: `तकनीकी समस्याओं का पता लगाने, उन्हें रोकने और उनका पता लगाने के लिए`,

  ourpolicies_typeofdata_use_list7: `आपको अन्य वस्तुओं, सेवाओं और घटनाओं के बारे में समाचार, विशेष ऑफ़र और सामान्य जानकारी प्रदान करने के लिए, जो हम प्रदान करते हैं, जो उन लोगों के समान हैं जिन्हें आपने पहले ही खरीदा है या पूछताछ की है जब तक कि आपने ऐसी जानकारी प्राप्त नहीं करने का विकल्प चुना है।`,

  ourpolicies_typeofdata_legalbasis_title: `सामान्य डेटा संरक्षण विनियमन (GDPR) के तहत व्यक्तिगत डेटा को संसाधित करने के लिए कानूनी आधार`,

  ourpolicies_typeofdata_legalbasis_content1: `यदि आप यूरोपीय आर्थिक क्षेत्र (ईईए) से हैं, तो सिवी इंक। इस गोपनीयता नीति में वर्णित व्यक्तिगत जानकारी एकत्र करने और उपयोग करने का कानूनी आधार हमारे द्वारा एकत्र किए गए व्यक्तिगत डेटा और उस विशिष्ट संदर्भ पर निर्भर करता है जिसमें हम इसे एकत्र करते हैं।`,

  ourpolicies_typeofdata_legalbasis_content2: `Civy Inc. आपके व्यक्तिगत डेटा को संसाधित कर सकता है क्योंकि:`,

  ourpolicies_typeofdata_legalbasis_list1: `हमें आपके साथ एक अनुबंध करने की आवश्यकता है`,

  ourpolicies_typeofdata_legalbasis_list2: `आपने हमें ऐसा करने की अनुमति दी है`,

  ourpolicies_typeofdata_legalbasis_list3: `प्रसंस्करण हमारे वैध हितों में है और यह आपके अधिकारों से अधिक नहीं है`,

  ourpolicies_typeofdata_legalbasis_list4: `भुगतान प्रसंस्करण प्रयोजनों के लिए`,

  ourpolicies_typeofdata_legalbasis_list5: `कानून का पालन करना`,

  ourpolicies_typeofdata_retention_title: `डेटा का अवधारण`,

  ourpolicies_typeofdata_retention_content1: `Civy Inc. आपके व्यक्तिगत डेटा को केवल उसी समय तक बनाए रखेगा जब तक इस गोपनीयता नीति में निर्धारित उद्देश्यों के लिए आवश्यक है। हम आपके व्यक्तिगत डेटा को हमारे कानूनी दायित्वों का पालन करने के लिए आवश्यक सीमा तक उपयोग करेंगे (उदाहरण के लिए, यदि हमें लागू कानूनों का पालन करने के लिए आपके डेटा को बनाए रखना आवश्यक है), विवादों को हल करें और हमारे कानूनी समझौतों और नीतियों को लागू करें।`,

  ourpolicies_typeofdata_retention_content2: `Civy Inc. आंतरिक विश्लेषण उद्देश्यों के लिए उपयोग डेटा को भी बनाए रखेगा। उपयोग डेटा आमतौर पर कम समय के लिए बनाए रखा जाता है, सिवाय जब इस डेटा का उपयोग सुरक्षा को मजबूत करने या हमारी सेवा की कार्यक्षमता को बेहतर बनाने के लिए किया जाता है, या हम इस डेटा को लंबे समय तक बनाए रखने के लिए कानूनी रूप से बाध्य हैं।`,

  ourpolicies_typeofdata_transfer_title: `डेटा का स्थानांतरण`,

  ourpolicies_typeofdata_transfer_content1: `आपकी जानकारी, जिसमें व्यक्तिगत डेटा भी शामिल है, को आपके राज्य, प्रांत, देश या अन्य सरकारी क्षेत्र से बाहर स्थित कंप्यूटरों पर स्थानांतरित किया जा सकता है, जहां डेटा संरक्षण कानून आपके क्षेत्राधिकार से भिन्न हो सकते हैं।`,

  ourpolicies_typeofdata_transfer_content2: `यदि आप संयुक्त राज्य अमेरिका के बाहर स्थित हैं और हमें जानकारी प्रदान करने के लिए चुनते हैं, तो कृपया ध्यान दें कि हम व्यक्तिगत डेटा सहित डेटा को संयुक्त राज्य अमेरिका में स्थानांतरित करते हैं और इसे वहां संसाधित करते हैं।`,

  ourpolicies_typeofdata_transfer_content3: `इस जानकारी को प्रस्तुत करने के बाद आपकी गोपनीयता नीति के लिए आपकी सहमति उस हस्तांतरण में आपके समझौते का प्रतिनिधित्व करती है।`,

  ourpolicies_typeofdata_transfer_content4: `Civy Inc. यह सुनिश्चित करने के लिए सभी आवश्यक कदम उठाएगी कि आपका डेटा सुरक्षित रूप से व्यवहार किया जाए और इस गोपनीयता नीति के अनुसार और आपके व्यक्तिगत डेटा का कोई हस्तांतरण किसी संगठन या देश में तब तक नहीं होगा जब तक कि इसमें पर्याप्त नियंत्रण शामिल न हों आपके डेटा और अन्य व्यक्तिगत जानकारी की सुरक्षा।`,

  ourpolicies_disclosure_title: `डेटा का प्रकटीकरण`,

  ourpolicies_disclosure_law_title: `कानून प्रवर्तन के लिए प्रकटीकरण `,

  ourpolicies_disclosure_law_content: `कुछ परिस्थितियों में, सिवी इंक को आपके व्यक्तिगत डेटा का खुलासा करने की आवश्यकता हो सकती है यदि कानून द्वारा या सार्वजनिक अधिकारियों द्वारा वैध अनुरोधों के जवाब में (जैसे कि एक अदालत या एक सरकारी एजेंसी) आवश्यक हो।`,

  ourpolicies_disclosure_requirement_title: `कानूनी आवश्यकताएं`,

  ourpolicies_disclosure_requirement_content: `Civy Inc. आपके व्यक्तिगत डेटा को सद्भावना विश्वास में प्रकट कर सकती है कि इस तरह की कार्रवाई आवश्यक है:`,

  ourpolicies_disclosure_requirement_list1: `एक कानूनी दायित्व का पालन करने के लिए`,

  ourpolicies_disclosure_requirement_list2: `सिवी इंक के अधिकारों या संपत्ति की रक्षा और बचाव के लिए।`,

  ourpolicies_disclosure_requirement_list3: `सेवा के संबंध में संभावित गलत काम को रोकने या जांच करने के लिए`,

  ourpolicies_disclosure_requirement_list4: `सेवा या जनता के उपयोगकर्ताओं की व्यक्तिगत सुरक्षा की रक्षा करने के लिए`,

  ourpolicies_disclosure_requirement_list5: `कानूनी दायित्व से बचाने के लिए`,

  ourpolicies_security_title: `डेटा की सुरक्षा`,

  ourpolicies_security_content: `आपके डेटा की सुरक्षा हमारे लिए महत्वपूर्ण है, लेकिन याद रखें कि इंटरनेट पर संचरण की कोई विधि या इलेक्ट्रॉनिक भंडारण की विधि 100% सुरक्षित नहीं है। यद्यपि हम आपके व्यक्तिगत डेटा की सुरक्षा के लिए व्यावसायिक रूप से स्वीकार्य साधनों का उपयोग करने का प्रयास करते हैं, हम इसकी पूर्ण सुरक्षा की गारंटी नहीं दे सकते।`,

  ourpolicies_security_policy: `हमारी नीति - संयुक्त राज्य अमेरिका में सामान्य आवेदन, जिसमें कैलिफोर्निया राज्य के लिए विशिष्ट नीतियां शामिल हैं।`,

  ourpolicies_security_track: `"ऑनलाइन ट्रैक न करें" कैलिफोर्निया ऑनलाइन संरक्षण अधिनियम (CalOPPA) के तहत सिग्नल`,

  ourpolicies_security_track_content1: `हम Do Not Track ("DNT") का समर्थन नहीं करते हैं। नॉट ट्रैक एक ऐसी प्राथमिकता है जिसे आप अपने वेब ब्राउज़र में उन वेबसाइटों को सूचित करने के लिए सेट कर सकते हैं जिन्हें आप ट्रैक नहीं करना चाहते हैं।`,

  ourpolicies_security_track_content2: `आप अपने वेब ब्राउज़र की वरीयताएँ या सेटिंग पृष्ठ पर जाकर Do Not Track को सक्षम या अक्षम कर सकते हैं।`,

  ourpolicies_security_privacy_policy: `कैलिफोर्निया उपभोक्ता गोपनीयता अधिनियम (CCPA) का अनुपालन करने के लिए हमारी नीति`,

  ourpolicies_security_privacy_policy1: `जानने का अधिकार:`,

  ourpolicies_security_privacy_policy1_content: `निवासियों को यह अनुरोध करने का अधिकार है कि हम यह खुलासा करें कि हमारे द्वारा व्यक्तिगत जानकारी एकत्र, उपयोग, साझा या बेची गई है।`,

  ourpolicies_security_privacy_policy2: `हटाने का अधिकार:`,

  ourpolicies_security_privacy_policy2_content: `निवासियों को यह अनुरोध करने का अधिकार है कि हम और हमारे सेवा प्रदाता, आपके पास मौजूद व्यक्तिगत जानकारी को हटा दें।`,

  ourpolicies_security_privacy_policy3: `ऑप्ट-आउट करने का अधिकार:`,

  ourpolicies_security_privacy_policy3_content: `निवासियों को अपनी व्यक्तिगत जानकारी की बिक्री को रोकने के लिए हमें निर्देशित करने का अधिकार है, जिस स्थिति में हम व्यक्तिगत जानकारी "बेचते हैं" क्योंकि यह शब्द CCPA द्वारा परिभाषित है। कृपया ध्यान दें कि सिवी के प्लेटफ़ॉर्म पर एकत्र किए गए डेटा केवल सिवी के ग्राहकों के लिए उपलब्ध हैं, जिसमें संयुक्त राज्य अमेरिका के सरकारी क्षेत्र (शहर, मुन्सिपल, परिषद, सरकारी एजेंसियां विशेष जिले और पंजीकृत निवासी) शामिल हैं। Civy विज्ञापन-प्रसार या निजी जैसे तृतीय-पक्ष को डेटा बेचने या बेचने का इरादा नहीं करता है कंपनियों।`,

  ourpolicies_security_privacy_policy4: `गैर-भेदभाव का अधिकार:`,

  ourpolicies_security_privacy_policy4_content: `जब हम CCPA के तहत अपने गोपनीयता अधिकारों का प्रयोग करते हैं, तो हम मूल्य या सेवा के मामले में निवासियों के साथ भेदभाव नहीं कर सकते हैं।`,

  ourpolicies_security_protection_title: `सामान्य डेटा सुरक्षा विनियमन (GDPR) के तहत आपका डेटा सुरक्षा अधिकार`,

  ourpolicies_security_protection_content1: `यदि आप यूरोपीय आर्थिक क्षेत्र (EEA) के निवासी हैं, तो आपके पास कुछ डेटा सुरक्षा अधिकार हैं। सिवी इंक का उद्देश्य आपके व्यक्तिगत डेटा के उपयोग को सही करने, संशोधन करने, हटाने या सीमित करने की अनुमति देने के लिए उचित कदम उठाना है।`,

  ourpolicies_security_protection_content2: `यदि आप इस बारे में सूचित करना चाहते हैं कि हम आपके बारे में क्या व्यक्तिगत डेटा रखते हैं और यदि आप चाहते हैं कि यह हमारे सिस्टम से हटा दिया जाए, तो कृपया हमसे संपर्क करें।`,

  ourpolicies_security_protection_content3: `कुछ परिस्थितियों में, आपके पास निम्नलिखित डेटा सुरक्षा अधिकार हैं:`,

  ourpolicies_security_access_title: `हमारे पास आपके पास मौजूद जानकारी तक पहुंचने, अपडेट करने या हटाने का अधिकार है।`,

  ourpolicies_security_access_content1: `जब भी संभव हो, आप अपने व्यक्तिगत डेटा को सीधे अपने खाता सेटिंग अनुभाग में हटा सकते हैं, अपडेट या अनुरोध कर सकते हैं। यदि आप स्वयं इन क्रियाओं को करने में असमर्थ हैं, तो कृपया हमसे सहायता के लिए संपर्क करें।`,

  ourpolicies_security_rectification_title: `सुधार का अधिकार।`,

  ourpolicies_security_rectification_content: `यदि आपकी जानकारी गलत या अधूरी है, तो आपको अपनी जानकारी को सुधारने का अधिकार है।`,

  ourpolicies_security_object_title: `आपत्ति करने का अधिकार।`,

  ourpolicies_security_object_content: `आपको हमारे व्यक्तिगत डेटा के हमारे प्रसंस्करण पर आपत्ति करने का अधिकार है।`,

  ourpolicies_security_restriction_title: `प्रतिबंध का अधिकार।`,

  ourpolicies_security_restriction_content: `आपको यह अनुरोध करने का अधिकार है कि हम आपकी व्यक्तिगत जानकारी के प्रसंस्करण को प्रतिबंधित करते हैं।`,

  ourpolicies_security_portability_title: `डेटा पोर्टेबिलिटी का अधिकार।`,

  ourpolicies_security_portability_content: `आपके पास संरचित, मशीन-पठनीय और आमतौर पर उपयोग किए जाने वाले प्रारूप में आपके पास मौजूद जानकारी की एक प्रति के साथ प्रदान करने का अधिकार है।`,

  ourpolicies_security_withdraw_title: `सहमति वापस लेने का अधिकार।`,

  ourpolicies_security_withdraw_content: `आपके पास किसी भी समय अपनी सहमति वापस लेने का अधिकार है जहां Civy Inc. आपकी व्यक्तिगत जानकारी को संसाधित करने के लिए आपकी सहमति पर निर्भर है।`,

  ourpolicies_security_protection_content4: `कृपया ध्यान दें कि ऐसे अनुरोधों का जवाब देने से पहले हम आपसे आपकी पहचान सत्यापित करने के लिए कह सकते हैं।`,

  ourpolicies_security_protection_content5: `आपको हमारे व्यक्तिगत डेटा के संग्रह और उपयोग के बारे में डेटा सुरक्षा प्राधिकरण से शिकायत करने का अधिकार है। अधिक जानकारी के लिए, कृपया अपने स्थानीय डेटा संरक्षण प्राधिकरण से यूरोपीय आर्थिक क्षेत्र (EEA) में संपर्क करें।`,

  ourpolicies_serviceprovider: `सेवा प्रदाता`,

  ourpolicies_serviceprovider_content1: `हम अपनी सेवा ("सेवा प्रदाता") की सुविधा के लिए तीसरे पक्ष की कंपनियों और व्यक्तियों को नियुक्त कर सकते हैं, हमारी ओर से सेवा प्रदान कर सकते हैं, सेवा से संबंधित सेवाएं कर सकते हैं या हमारी सेवा का उपयोग कैसे किया जाता है इसका विश्लेषण करने में हमारी सहायता कर सकते हैं।`,

  ourpolicies_serviceprovider_content2: `इन तृतीय पक्षों के पास आपकी व्यक्तिगत डेटा तक केवल हमारी ओर से इन कार्यों को करने के लिए पहुंच है और यह किसी अन्य उद्देश्य के लिए इसका खुलासा या उपयोग नहीं करने के लिए बाध्य है।`,

  ourpolicies_serviceprovider_analytics: `एनालिटिक्स`,

  ourpolicies_serviceprovider_analytics_content: `हम अपनी सेवा के उपयोग की निगरानी और विश्लेषण करने के लिए तृतीय-पक्ष सेवा प्रदाताओं का उपयोग कर सकते हैं।`,

  ourpolicies_serviceprovider_ganalytics: `गूगल विश्लेषिकी`,

  ourpolicies_serviceprovider_ganalytics_content1: `Google Analytics Google द्वारा दी जाने वाली एक वेब विश्लेषिकी सेवा है जो वेबसाइट ट्रैफ़िक को ट्रैक और रिपोर्ट करती है। Google हमारी सेवा के उपयोग को ट्रैक और मॉनिटर करने के लिए एकत्रित डेटा का उपयोग करता है। यह डेटा अन्य Google सेवाओं के साथ साझा किया गया है। Google एकत्रित डेटा का उपयोग अपने विज्ञापन नेटवर्क के विज्ञापनों को प्रासंगिक बनाने और निजीकृत करने के लिए कर सकता है।`,

  ourpolicies_serviceprovider_ganalytics_content2: `Google की गोपनीयता प्रथाओं के बारे में अधिक जानकारी के लिए, कृपया Google गोपनीयता शर्तें वेब पेज पर जाएं: https://polatics.google.com/privacy?hl=hi`,

  ourpolicies_serviceprovider_firebase: `Firebase`,

  ourpolicies_serviceprovider_firebase_content1: `फायरबेस Google इंक द्वारा प्रदान की जाने वाली एक विश्लेषिकी सेवा है।`,

  ourpolicies_serviceprovider_firebase_content4: `आप अपनी मोबाइल डिवाइस सेटिंग्स, जैसे कि आपकी डिवाइस विज्ञापन सेटिंग या Google द्वारा उनकी गोपनीयता नीति में दिए गए निर्देशों का पालन करके कुछ फायरबेस सुविधाओं से ऑप्ट-आउट कर सकते हैं: https://polatics.google.com/privacy?hl=en`,

  ourpolicies_serviceprovider_firebase_content2: `हम आपको अपने डेटा की सुरक्षा के लिए Google की नीति की समीक्षा करने के लिए भी प्रोत्साहित करते हैं: https://support.google.com/analytics/answer/6004245।`,

  ourpolicies_serviceprovider_firebase_content3: `किस प्रकार की जानकारी फायरबेस के बारे में अधिक जानकारी के लिए एकत्रित, कृपया Google गोपनीयता शर्तें वेब पेज पर जाएँ: https://policies.google.com/privacy?hl=en`,

  ourpolicies_serviceprovider_payments: `भुगतान`,

  ourpolicies_serviceprovider_payment_content1: `हम सेवा के भीतर भुगतान किए गए उत्पाद और / या सेवाएं प्रदान कर सकते हैं। उस स्थिति में, हम भुगतान प्रसंस्करण (जैसे भुगतान प्रोसेसर) के लिए तृतीय-पक्ष सेवाओं का उपयोग करते हैं।`,

  ourpolicies_serviceprovider_payment_content2: `हम आपके भुगतान कार्ड का विवरण संग्रहीत या एकत्र नहीं करेंगे। यह जानकारी सीधे हमारे तृतीय-पक्ष भुगतान प्रोसेसर को प्रदान की जाती है, जिनकी व्यक्तिगत जानकारी का उपयोग उनकी गोपनीयता नीति द्वारा नियंत्रित होता है। ये भुगतान प्रोसेसर पीसीआई-डीएसएस द्वारा निर्धारित मानकों का पालन करते हैं जैसा कि पीसीआई सुरक्षा मानक परिषद द्वारा प्रबंधित किया जाता है, जो वीज़ा मास्टरकार्ड, अमेरिकन एक्सप्रेस और डिस्कवर जैसे ब्रांडों का संयुक्त प्रयास है। PCI-DSS आवश्यकताओं को भुगतान जानकारी की सुरक्षित हैंडलिंग सुनिश्चित करने में मदद करता है।`,

  ourpolicies_serviceprovider_payment_content3: `हमारे द्वारा काम करने वाले भुगतान प्रोसेसर हैं:`,

  ourpolicies_serviceprovider_stripe: `Stripe`,

  ourpolicies_serviceprovider_stripe_content: `उनकी गोपनीयता नीति https://stripe.com/us गोपनीयता पर देखी जा सकती है`,

  ourpolicies_linksto_title: `अन्य साइटों के लिंक`,

  ourpolicies_linksto_content1: `हमारी सेवा में अन्य साइटों के लिंक हो सकते हैं जो हमारे द्वारा संचालित नहीं हैं। यदि आप किसी तीसरे पक्ष के लिंक पर क्लिक करते हैं, तो आपको उस तीसरे पक्ष की साइट पर निर्देशित किया जाएगा। हम आपको दृढ़ता से सलाह देते हैं कि आपके द्वारा देखी जाने वाली प्रत्येक साइट की गोपनीयता नीति की समीक्षा करें।`,

  ourpolicies_linksto_content2: `हमारा किसी तीसरे पक्ष की साइटों या सेवाओं की सामग्री, गोपनीयता नीतियों या प्रथाओं के लिए कोई नियंत्रण नहीं है।`,

  ourpolicies_children_title: `बच्चों की गोपनीयता`,

  ourpolicies_children_content1: `हमारी सेवा 18 वर्ष ("बच्चे") के तहत किसी को भी संबोधित नहीं करती है।`,

  ourpolicies_children_content2: `हम जानबूझकर 18 वर्ष से कम उम्र के किसी से भी व्यक्तिगत रूप से पहचान योग्य जानकारी एकत्र नहीं करते हैं। यदि आप एक माता-पिता या अभिभावक हैं और आप जानते हैं कि आपके बच्चे ने हमें व्यक्तिगत डेटा प्रदान किया है, तो कृपया हमसे संपर्क करें। यदि हमें पता है कि हमने माता-पिता की सहमति के सत्यापन के बिना बच्चों से व्यक्तिगत डेटा एकत्र किया है, तो हम अपने सर्वर से उस जानकारी को हटाने के लिए कदम उठाते हैं।`,

  ourpolicies_changes_title: `इस गोपनीयता नीति में परिवर्तन`,

  ourpolicies_changes_content1: `हम समय-समय पर अपनी गोपनीयता नीति को अपडेट कर सकते हैं। हम इस पृष्ठ पर नई गोपनीयता नीति पोस्ट करके आपको किसी भी बदलाव के बारे में सूचित करेंगे।`,

  ourpolicies_changes_content2: `हम आपको इस सेवा के प्रभावी होने से पहले ईमेल और / या हमारी सेवा के बारे में एक प्रमुख सूचना के माध्यम से अवगत कराएंगे।`,

  ourpolicies_changes_content3: `आपको किसी भी बदलाव के लिए समय-समय पर इस गोपनीयता नीति की समीक्षा करने की सलाह दी जाती है। इस पेज पर पोस्ट किए जाने पर इस गोपनीयता नीति में परिवर्तन प्रभावी हैं।`,

  ourpolicies_contactus_title: `संपर्क करें`,

  ourpolicies_contactus_content1: `यदि इस गोपनीयता नीति के बारे में आपके कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें:`,

  ourpolicies_contactus_content2: `ईमेल द्वारा:`,

  //Registration page
  dob_validation: "आयु कम से कम 16 होनी चाहिए",

  register_regi_title: "खाता पंजीकृत करें",

  register_dob_error: "*जन्म तिथि की आवश्यकता है",

  register_age_error: "*कृपया अपनी आयु सीमा चुनें।",

  register_organization_label: "संस्था का नाम{star}",
  profile_name_label: "नाम{star}",

  date_invalid_error: "कृपया मान्य दिनांक दर्ज करें।",

  register_organization_error: "* संगठन का नाम आवश्यक है",
  profile_name_error: "*नाम आवश्यक है",

  register_organization_type_label: "संगठन का प्रकार{star}",
  profile_type_label: "प्रकार{star}",

  register_organization_type_error: "* कृपया संगठन प्रकार का चयन करें",
  profile_type_error: "*प्रकार का चयन करें",

  register_organization_title_label: "संगठन का शीर्षक{star}",
  profile_title_label: "शीर्षक{star}",

  register_organization_title_error: "* शीर्षक आवश्यक है",

  register_browse_label: "ब्राउज़ करें ...",

  register_upload_label: "लोगो अपलोड करें",

  register_upload_error: "* कृपया लोगो का चयन करें",

  register_are_you_label: "क्या तुम एक{star}",

  register_are_you_resident: "यूएस निवासी",

  register_are_you_citizen: "संयुक्त राज्य अमेरिका के नागरिक",

  register_are_you_prefer: "जवाब नहीं देना पसंद",

  register_are_you_error: "* टाइप का चयन करें",

  register_your_title_label: "शीर्षक{star}",

  register_your_title_list1: "श्री.",

  register_your_title_list2: "कुमारी.",

  register_your_title_list3: "श्रीमती.",

  register_your_title_list4: "डॉ.",

  register_your_title_list5: "एमएस.",

  register_your_title_error: "* कृपया अपना शीर्षक चुनें",

  register_name_label: "पहला नाम{star}",

  register_name_error1: "*पहला नाम आवश्यक है",

  register_name_error2: "15-20 पाठ अनुमति की सीमा होनी चाहिए।",

  register_last_name_label: "अंतिम नाम{star}",

  register_last_name_error1: "* अंतिम नाम आवश्यक है",

  register_last_name_error2: "15-20 पाठ अनुमति की सीमा होनी चाहिए।",

  register_ethinicicty_label: "जातीयता{star}",

  register_ethinicicty_error: "* कृपया एक जातीयता का चयन करें",

  register_email_label: "ईमेल{star}",

  register_email_error1: "*ईमेल जरुरी है",

  register_email_error2: "कृपया मान्य ईमेल पता दर्ज करें",

  register_mobile_label: "मोबाइल नम्बर{star}",

  register_mobile_error1: "* मोबाइल नंबर आवश्यक है",

  register_gender_label: "लिंग{star}",

  register_gender_type1: "नर",

  register_gender_type2: "महिला",

  register_gender_type3: "अन्य",

  register_gender_error: "*कृपया लिंग चुनें",

  register_birth_label: "जन्म की तारीख{star}",

  register_street_label: "गली का पता{star}",

  register_street_error: "* स्ट्रीट एडेस की आवश्यकता है",

  register_apartment_label: "इमारत का कमरा{star}",

  register_apartment_error: "* अपार्टमेंट / सुइट की आवश्यकता है",

  register_country_label: "देश {star}",

  register_country_error: "* कृपया देश चुनें",

  register_state_label: "राज्य {star}",

  register_state_error: "* कृपया राज्य चुनें",

  register_city_label: "शहर{star}",

  register_county_label: "काउंटी{star}",

  register_city_error: "* कृपया शहर चुनें",

  register_zip_label: "पिन कोड{star}",

  register_zip_error: "* ज़िप कोड फ़ील्ड की आवश्यकता है",

  register_zip2_label: "+4 कोड",

  register_password_label: "कुंजिका{star}",

  register_password_error1: "* पासवर्ड फ़ील्ड आवश्यक है",

  register_password_error2:
    "पासवर्ड में अपरकेस, लोअरकेस अक्षर और संख्याओं सहित कम से कम 8 अक्षर होने चाहिए।",

  register_terms1_label: "मैं इसके लिए सहमत हूँ",

  register_terms2_label: "उपयोग की शर्तें",

  register_terms3_label: "तथा",

  register_terms4_label: "गोपनीयता नीति",

  register_terms_error:
    "* कृपया इंगित करें कि आप नियम और गोपनीयता नीति को स्वीकार करते हैं",

  register_already_account: "क्या आपके पास पहले से एक खाता मौजूद है,",

  register_signin_label: "साइन इन करें",

  register_or_signin_label: "या के साथ साइन इन करें",

  register_registerbutton_label: "रजिस्टर करें",

  register_organization_type1: "शहर",

  register_organization_type2: "सरकार",

  register_organization_type3: "म्युनिसिपल",

  register_organization_type4: "व्यवसाय सुधार जिले",

  register_organization_type5: "प्रबुद्ध मंडल",

  register_organization_type6: "उच्च एड",

  register_ethinicity_type1: "अफ्रीकी अमेरिकी",

  register_ethinicity_type2: "भारतीय अमेरिकन या अलास्का का मूल निवासी",

  register_ethinicity_type3: "एशियाई या प्रशांत द्वीपसमूह",

  register_ethinicity_type4: "कोकेशियान",

  register_ethinicity_type5: "हिस्पैनिक या लैटिनो",

  register_ethinicity_type6: "देशी हवाईयन या अन्य प्रशांत द्वीप वासी",

  register_ethinicity_type7: "बहुजातीय",

  register_ethinicity_type8: "अन्य",

  register_ethinicity_type9: "जवाब नहीं देना पसंद",

  register_profile_change_password: "पासवर्ड बदलें",

  register_create_password_change: "अपना पासवर्ड बदलें",

  register_create_password_create: "अपना पासवर्ड बनाएँ",

  register_create_password_old: "पुराना पासवर्ड*",

  register_create_password_new: "नया पासवर्ड*",

  register_create_password_confirm: "पासवर्ड की पुष्टि कीजिये*",

  register_create_password_not_match: "*पासवर्ड नही मिल रहा",

  register_create_password_cotinue: "जारी रखें",

  register_collegues_add_collegues: "सहकर्मियों को जोड़ें",

  register_department_label: "विभाग{star}",

  register_department_error: "* विभाग की आवश्यकता है",

  register_member_no_colleagues: "कोई सहकर्मी नहीं जोड़ा गया",

  register_member_colleagues_list: "सहकर्मियों की सूची",
  register_member_colleague_list: "सहकर्मि की सूची",

  register_member_delete: "हटाएं",

  register_profile_upload_resident: "निवासी डेटा अपलोड करें",

  register_profile_batch_upload: "अपलोड अपलोड करें",

  register_profile_resident_details: "निवासी विवरण टेम्पलेट",

  //Login page

  login_signin_label: "साइन इन करें",

  login_email_label: "ईमेल",

  login_email_error1: "*ईमेल जरुरी है",

  login_email_error2: "*कृपया मान्य ईमेल पता दर्ज करें",

  login_password_label: "कुंजिका",

  login_password_error1: "* पासवर्ड फ़ील्ड आवश्यक है",

  login_password_error2:
    "पासवर्ड में अपरकेस, लोअरकेस अक्षर और संख्याओं सहित कम से कम 8 अक्षर होने चाहिए।",

  login_checkbox_label: "मुझे याद रखना",

  login_loginbutton_label: "लॉग इन करें",

  login_orsignin_label: "या के साथ साइन इन करें",

  login_forgot_password_label: "पासवर्ड भूल गए?",

  login_registration_label1: "खाता नहीं है?",

  login_resident_label1: "निवासी खाता बनाएँ",

  login_resident_label2: "खाता बनाएं",

  login_organization_label1: "संगठन खाता बनाएँ",

  login_forgot_password_submit: "प्रस्तुत",

  //404 Not found Page and thank you page

  notfound_thankyou_content1: "सिवी को चुनने के लिए,",

  notfound_thankyou_content2: "कृपया अपनी ईमेल देखें। हमने भेज दिया है",

  notfound_thankyou_content3: "आप पुष्टि के लिए एक ईमेल",

  notfound_thankyou_content4: "घर वापिस जा रहा हूँ",

  //header banner

  header_banner_about: "के बारे में",

  header_banner_contactus: "संपर्क करें",

  header_banner_service: "सेवाएं",

  header_banner_outpolicies: "हमारी नीतियां",

  header_banner_project: "परियोजना",

  header_banner_thought_leadership: "वैचारिक नेतृत्व",

  header_banner_how_to: "कैसे",

  header_home_banner:
    "कनेक्टिंग सरकार और समितियों के माध्यम से इनोवेटिव प्लैटफ़ॉर्म्स",

  header_banner_colleagues: "साथि",

  header_banner_change_password: "पासवर्ड बदलें",

  header_banner_create_password: "पासवर्ड बनाएं",

  header_banner_survey: "सर्वेक्षण",

  header_banner_what_is_civy: "नागरिक क्या है?",

  header_banner_qr_code_management: "क्यूआर कोड प्रबंधन",

  //header.........................

  header_home: "घर",

  header_core: "कोर 19",

  header_KIOSK: "कीओस्क",

  header_service: "सेवा",

  header_project: "परियोजनाओं",

  header_project_engage: "संलग्न",

  header_thought_leadership: "वैचारिक नेतृत्व",

  header_about: "के बारे में",

  header_login: "लॉग इन करें",

  // header_language1: "अंग्रेज़ी",

  // header_language2: "फ्रेंच",

  // header_language3: "स्पेनिश",

  // header_language4: "हिन्दी",

  // header_language5: "अकर्मण्य",

  // header_language6: "इतालवी",

  // header_language7: "वियतनामी",
  header_language1: "EN",

  header_language2: "FR",

  header_language3: "ES",

  header_language4: "HI",

  header_language5: "ZH",

  header_language6: "IT",

  header_language7: "VI",

  header_header_drawer_welcome: "स्वागत हे,",

  header_header_drawer_admin_profile: "व्यवस्थापक प्रोफ़ाइल",

  header_header_drawer_profile: "प्रोफ़ाइल",

  header_header_drawer_colleagues: "साथियों",

  header_header_drawer_op_ed: "ओप-एड",

  header_header_drawer_how_to: "कैसे",

  header_header_drawer_logout: "लॉग आउट",

  header_what_is_civy: "नागरिक क्या है?",

  header_qr_code_management: "क्यूआर कोड प्रबंधन",

  //footer........................

  footer_contactus_title: "संपर्क करें",

  footer_contactus_content1:
    "सिविक से संपर्क करें यह जानने के लिए कि आप सभी जनसांख्यिकी के निवासियों के लिए अपने सामुदायिक विकास परियोजनाओं के लिए बेहतर नागरिक जुड़ाव कैसे सक्षम कर सकते हैं।",

  footer_media: "मीडिया",

  footer_terms_title: "उपयोग की शर्तें",

  footer_privacy_title: "गोपनीयता नीति",

  footer_google_translate_message: `सिवी प्लेटफ़ॉर्म में उपलब्ध अन्य भाषाओं को अंग्रेज़ी से परिवर्तित करने के लिए Google Translate का उपयोग करता है। कई बार, Google अनुवाद सटीक अनुवाद प्रदान नहीं कर सकता है। किसी भी प्रश्न के लिए, कृपया हमसे संपर्क करें`,

  // blog details page..............

  blog_details_author_title: "लेखक",

  blog_details_author_title_star: "लेखक{star}",

  blog_details_posted_title: "प्रकाशित किया गया था:",

  blog_details_latest_article_title: "नवीनतम लेख",

  blog_details_op_ed_title: "सिवी ओप-एड",

  blog_addblog_new_blog: "नया ओप-एड जोड़ें",

  blog_addblog_title: "शीर्षक",

  blog_addblog_description_title: "विवरण",

  blog_addblog_browse_title: "ब्राउज़ करें ...",

  blog_addblog_addimage_title: "छवि जोड़ें..",

  blog_addblog_submit_title: "अनुच्छेद जोड़ें",

  blog_editblog_op_ed_title: "ओप-एड संपादित करें",

  blog_common_error: "*यह फ़ील्ड आवश्यक है",

  commonn_update_button: "अपडेट करें",

  blog_title_error: "*शीर्षक आवश्यक है",

  blog_desc_error: "*विवरण की आवश्यकता है",

  blog_author_error: "*लेखक की आवश्यकता है",

  blog_image_error: "*छवि आवश्यक है",

  valid_image_error: "*छवियाँ .png, .jpeg, .jpg में होनी चाहिए",

  //project page.........................

  project_filter_project_type1: "नया काम",

  project_filter_project_type2: "मौजूदा परियोजना",

  project_filter_project_type3: "मरम्मत / रखरखाव",

  project_filter_project_type4: "प्रतिस्पर्धा",

  project_filter_project_type5: "आपदा",

  project_filter_project_category1: "हरियाली",

  project_filter_project_category2: "टोल शुल्क",

  project_filter_project_category3: "उपयोगिताएँ",

  project_filter_project_category4: "सड़कें",

  project_filter_project_category5: "राजमार्ग",

  project_filter_project_category6: "व्यावसायिक इमारत",

  project_filter_project_category7: "आवासीय भवन",

  project_filter_project_category8: "जन्म का देश",

  project_filter_project_category9: "सामुदायिक क्लब भवन",

  project_filter_project_category10: "मामूली काम करता है",

  project_filter_city_zipcode: "काउंटी, शहर और ज़िप",

  project_filter_range: "रेंज",

  project_filter_range1: "मील की दूरी पर",

  project_filter_project_type: "प्रोजेक्ट का प्रकार",

  project_filter_project_type_star: "प्रोजेक्ट का प्रकार{star}",

  project_filter_project_category: "प्रोजेक्ट श्रेणी",

  project_filter_project_category_star: "प्रोजेक्ट श्रेणी{star}",

  project_location: "स्थान{star}",

  project_street_address: "गली का पता",

  project_filter_add_new_project: "नया प्रोजेक्ट जोड़ें",

  project_filter_reset: "रीसेट",

  project_newproject_organization_label: "संगठन विभाग",

  project_newproject_organization_label_star: "संगठन विभाग{star}",

  project_newproject_common_error: "*यह फ़ील्ड आवश्यक है",

  project_newproject_street_label: "सड़क",

  project_newproject_country_label: "देश",

  project_newproject_state_label: "राज्य",

  project_newproject_city_label: "शहर",

  project_newproject_zipcode_label: "पिन कोड",

  project_newproject_areacode_label: "+4 कोड",

  project_newproject_start_date: "प्रोजेक्ट प्रारंभ दिनांक",

  project_newproject_end_date: "प्रोजेक्ट की अंतिम तिथि",

  project_newproject_cancel: "रद्द करना",

  project_projectfom_add_project: "प्रोजेक्ट जोड़ें",

  publish: "प्रकाशित करना",

  project_newproject_continue: "जारी रखें",

  project_projectlist_category_label: "वर्ग:",

  project_projectlist_type_label: "प्रकार:",

  project_projectlist_view_label: "प्रोजेक्ट देखें",

  project_projectlist_no_project: "कोई प्रोजेक्ट नहीं जोड़ा गया",

  project_editproject_edit: "प्रोजेक्ट संपादित करें",

  project_newproject_title_label: "परियोजना का शीर्षक",

  project_newproject_description: "परियोजना विवरण",

  project_newproject_description_star: "परियोजना विवरण{star}",

  project_newproject_add_images: "छवियां जोड़ें..",

  project_newproject_add_File: "पीडीएफ फाइलें अपलोड करें...",

  project_commentbox_join_label: "बातचीत में शामिल हों",

  project_commentbox_nocomment_label: "कोई टिप्पणी नहीं जोड़ी गई",

  project_commentbox_comment_label: "{commentlength} टिप्पणियाँ",

  project_details_location: "स्थान",

  project_details_posted: "पर पोस्ट किया गया",

  project_details_share: "साझा करें:",

  project_details_last_update: "पिछला नवीनीकरण",

  project_details_likes: "कुल पसंद:",

  project_details_question: "प्रश्न जोड़ें",

  project_details_question_list: "प्रश्न सूची",

  project_details_no_question: "कोई सवाल नहीं जोड़ा गया",

  project_details_add_answer: "उत्तर जोड़ें",

  project_details_add_answer_here: "यहाँ अपना उत्तर जोड़ें ...",

  project_facts_and_figures_label: "शहर और सरकारी कर्मचारियों से अपडेट",

  project_gallery_label: "प्रोजेक्ट गैलरी",

  qr_code_label: "QR कोड जनरेट करें",

  //Survey page............

  survey_select_questionType: "प्रश्न प्रकार चुनें",

  survey_questionType_content:
    "आपके प्रोजेक्ट का विवरण Civy पर सफलतापूर्वक अपलोड किया गया है। कृपया उन प्रश्नों के प्रकार का चयन करें जो आप निवासियों से पूछना चाहते हैं।",

  survey_questionType_type_a: "प्रकार अ",

  survey_questionType_type_que1:
    "1. कृपया बच्चों के खेल क्षेत्र के लिए अपनी समीक्षा जोड़ें।",

  survey_write_here_label: "यहाँ कुछ लिखो ...",

  survey_questionType_create_survey: "सर्वे बनाएं",

  survey_questionType_type_b: "बहुविकल्पी प्रश्न",

  survey_questionType_type_que2:
    "1. क्या आप सार्वजनिक उद्यान में बच्चों के खेलने के क्षेत्र को जोड़ना चाहेंगे?",

  survey_questionType_type_b_yes: "हाँ",

  survey_questionType_type_b_no: "नहीं",

  survey_comment_box: "ओपन एंडेड प्रश्न (कमेंट बॉक्स)",

  survey_radio_question_label: "प्रशन",

  survey_discard_label: "रद्द करें",

  survey_submit_label: "जोड़ें",

  survey_add_question_label: "प्रश्न जोड़ें",

  survey_back_label: "वापस",

  survey_question_list_label: "प्रश्न सूची",

  dialog_delete_message: "क्या आप वाकई हटाना चाहते हैं",

  delete_lable: "हटाएं",

  cancel_label: "रद्द करना",

  comment: "टिप्पणी",

  /* Validation message */

  departmaent_required: "*विभाग का नाम आवश्यक है",

  project_type_required: "*कृपया प्रोजेक्ट प्रकार चुनें",

  project_category_required: "*कृपया प्रोजेक्ट श्रेणी का चयन करें",

  location_required: "*स्थान की आवश्यकता है",

  full_address_required: "*कृपया पूरा पता दर्ज करें",

  only_usa_required: "*केवल यूएसए के लिए एक पता जोड़ें",

  project_title_requied: "*प्रोजेक्ट शीर्षक आवश्यक है",

  project_desc_required: "*परियोजना विवरण की आवश्यकता है",

  project_image_required: "छवि आवश्यक है",

  export_button: "एक्सेल में भेजे",

  export_project: "निर्यात परियोजना",

  export_project_data: "प्रोजेक्ट डेटा निर्यात करें",

  from: "से",

  to: "सेवा",

  project_required: "*कृपया प्रोजेक्ट चुनें",

  date_range: "तिथि सीमा",

  edit_question: "प्रश्न संपादित करें",

  quetion_labele: "सवाल",

  qustion_required: "*प्रश्न क्षेत्र की आवश्यकता है",

  click_edit: "प्रोफ़ाइल संपादित करने के लिए क्लिक करें",

  back_label: "वापस",

  save_label: "सेव",

  draft_label: "प्रारूप",

  upload_label: "डालना",

  attachment_label: "संलग्नक",

  rating_type_question: "रेटिंग प्रकार प्रश्न",

  survey_questionType_type_que3: "कृपया इस परियोजना को रेट करें",

  allow_cookie_text:
    "हम आपके अनुभव को अनुकूलित करने, ट्रैफ़िक का विश्लेषण करने और सामग्री को निजीकृत करने के लिए कुकीज़ का उपयोग करते हैं। अधिक जानने के लिए, कृपया हमारी कुकी नीति देखें। कुकीज़ को निष्क्रिय किए बिना हमारी वेबसाइट का उपयोग करके, आप उनमें से हमारे उपयोग के लिए सहमति देते हैं।.",

  allow_btn: "अनुमति",

  decline_btn: "पतन",

  cookie_policy: "कूकी नीति",

  /* What is civy page */

  civy_intro_title1: "मंच की विशेषताएं",

  civy_intro1_point1:
    "शहर और सरकारें एक समर्पित URL के माध्यम से मंच तक पहुँचती हैं, उदाहरण के लिए, {link}",

  civy_intro1_point2:
    "क्लाइंट के पास हमारे प्लेटफ़ॉर्म को उसके सोशल मीडिया पेजों (लिंक्डइन, फेसबुक और ट्विटर) से जोड़ने का विकल्प है ताकि व्यापक भागीदारी और सामुदायिक भागीदारी को बढ़ाया जा सके।",

  civy_intro1_point3: "प्लेटफ़ॉर्म में कई भाषाएँ शामिल हैं।",

  civy_intro1_point4:
    "डेटा को सिवी की क्लाउड सेवा पर संग्रहीत किया जाता है, और डेटा सुरक्षा और गोपनीयता को यूएस डेटा और गोपनीयता नियमों के अनुसार अर्ध-वार्षिक साइबर ऑडिट के साथ बनाए रखा जाता है।",

  civy_intro1_point5:
    "Civy तीसरे पक्ष के विज्ञापनदाताओं के साथ संलग्न नहीं होता है इसलिए दोनों ग्राहक और शहर विश्वास बनाए रख सकते हैं कि उन्हें कोई भी अवांछित ईमेल या प्रचार प्राप्त नहीं होगा।",

  civy_intro1_point6:
    "प्लेटफ़ॉर्म मोबाइल सुलभ है, दुनिया भर में कहीं भी; और सभी पंजीकृत उपयोगकर्ताओं के लिए ईमेल और एसएमएस सूचनाएं।",

  civy_intro1_point7:
    "परियोजनाओं के लिए QR कोड स्कैन (त्वरित प्रतिक्रिया प्रदान करने के लिए निवासियों द्वारा स्कैन)।",

  civy_intro1_point8:
    "सभी परियोजनाओं या चयनित परियोजनाओं के लिए उनके शहर से संबंधित डाउनलोड करने योग्य रिपोर्ट तक पहुंच।",

  civy_intro2_title: "संगठनों के पंजीकरण के कारण",

  civy_intro2_point1:
    "शहर के अपने लोगो के साथ एक व्यवस्थापक खाता बनाएँ और 20 सहयोगियों तक जोड़ें।",

  civy_intro2_point2:
    "ग्राहक द्वारा बनाया गया डेटा और निवासी प्रतिक्रिया ग्राहक के स्वामित्व में है।",

  civy_intro2_point3:
    "निवासी से प्रतिक्रिया सीधे परियोजना निर्माता को वापस भेज दी जाती है; उदाहरण के लिए, लोक निर्माण द्वारा बनाई गई परियोजना के लिए निवासी प्रतिक्रिया को सार्वजनिक कार्यों के लिए वापस निर्देशित किया जाता है।",

  civy_intro2_point4:
    "एकल या एकाधिक ज़िप कोड का उपयोग करके परियोजनाएं बनाई जा सकती हैं; एक स्थानीय शहर स्तर पर काउंटी स्तर; और सिवी और आपके जुड़े सोशल मीडिया चैनलों के माध्यम से साझा किया गया। यह सुनिश्चित करता है कि निवासियों द्वारा प्रतिक्रिया सीधे निवासी के ज़िप कोड से जुड़ी हुई है (न्यूयॉर्क शहर की परियोजनाओं द्वारा पोस्ट की गई परियोजनाओं को केवल न्यूयॉर्क निवासियों द्वारा जवाब दिया जा सकता है)।",

  civy_intro2_point5: "रिपोर्ट डाउनलोड करने में सक्षम।",

  civy_intro3_title: "निवासियों के पंजीकरण के लिए कारण",

  civy_intro3_point1:
    "यह सुनिश्चित करने के लिए कि आपका प्रोफ़ाइल उस ज़िप कोड से जुड़ा हुआ है जिसमें आप रहते हैं, और आप अपने शहर द्वारा पोस्ट किए गए प्रश्नों का उत्तर दे पाएंगे।",

  civy_intro3_point2:
    "यह सुनिश्चित करने के लिए कि आपकी प्रतिक्रियाएं आपके द्वारा सीधे प्रदान की जाती हैं। सिवी आपके किसी भी अन्य सोशल मीडिया अकाउंट से डेटा को लिंक, एकत्रित या एकत्र नहीं करता है। सिवी केवल आपके द्वारा सिवि के प्लेटफ़ॉर्म में उपलब्ध कराई गई प्रतिक्रियाओं को रिकॉर्ड करता है, और ये प्रतिक्रियाएं केवल प्लेटफ़ॉर्म का उपयोग करके शहर के अधिकारियों द्वारा समीक्षा के लिए दिखाई देती हैं।",

  civy_intro3_point3:
    "आपकी प्रतिक्रियाएँ या टिप्पणियां आपके साथी निवासियों को दिखाई नहीं देती हैं।",

  civy_intro3_point4:
    "आपको सिवी पर since गुमनाम ’के रूप में पंजीकरण करना होगा क्योंकि आपकी प्रतिक्रियाएँ गोपनीय होती हैं और केवल परियोजना के लिए जिम्मेदार शहर के अधिकारी द्वारा दिखाई देती हैं।",

  what_is_civy_policies_title: "नीतियों",

  what_is_civy_policies_content: "गोपनीयता और डेटा नीति",

  //QR code Management page

  qr_code_svg: "एसवीजी के रूप में उत्पन्न",

  qr_code_png: "पीएनजी के रूप में उत्पन्न",

  qr_code_jpeg: "जेपीईजी के रूप में उत्पन्न",

  qr_code: "क्यूआर कोड",
};
